'use client'
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/searchBar/index.tsx
import { SearchInput } from "@uhg-abyss/web/ui/SearchInput";
import { jsx } from "react/jsx-runtime";
var SearchBar = (props) => {
  return /* @__PURE__ */ jsx(SearchInput, __spreadValues({}, props));
};

// src/button/index.tsx
import { Button as AbyssButton } from "@uhg-abyss/web/ui/Button";
import { jsx as jsx2 } from "react/jsx-runtime";
var Button = (props) => {
  return /* @__PURE__ */ jsx2(AbyssButton, __spreadValues({}, props));
};

// src/categories/index.tsx
import React from "react";
import { IconBrand } from "@uhg-abyss/web/ui/IconBrand";
import { Layout } from "@uhg-abyss/web/ui/Layout";
import { Text } from "@uhg-abyss/web/ui/Text";
import { styled } from "@uhg-abyss/web/tools/styled";
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var CategoryButton = styled("button", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "2px",
  background: "#FBFBFB",
  minWidth: "6rem",
  minHeight: "5rem",
  border: "none",
  cursor: "pointer",
  padding: "8px 4px",
  lineHeight: "normal",
  borderRadius: "4px",
  "&:focus-visible": {
    outline: "2px solid #196ecf",
    outlineOffset: "2px"
  }
});
var Categories = ({
  categoryData,
  selectedCategory
}) => {
  const getIconNameFindhelp = (categoryLabel) => {
    switch (categoryLabel) {
      case "Care":
        return "care";
      case "Education":
        return "medal";
      case "Emergency":
        return "alert";
      case "Food":
        return "healthy_food";
      case "Goods":
        return "store";
      case "Health":
        return "heart_health";
      case "Housing":
        return "home";
      case "Legal":
        return "document_multiple";
      case "Money":
        return "cost";
      case "Transit":
        return "bus";
      case "Work":
        return "suitcase";
      default: {
        console.warn(`No icon found for category: ${categoryLabel}`);
        return "";
      }
    }
  };
  const handleKeyPress = (event2, category) => {
    if (event2.key === "Enter" || event2.key === " ") {
      selectedCategory(category);
    }
  };
  return /* @__PURE__ */ jsx3(React.Fragment, { children: /* @__PURE__ */ jsx3(
    Layout.Group,
    {
      style: {
        width: "100%",
        flexWrap: "wrap",
        alignItems: "flex-start"
      },
      className: "abyss-cat",
      children: categoryData.map((category) => {
        return /* @__PURE__ */ jsx3(
          "div",
          {
            style: {
              marginRight: "4px",
              borderTop: "solid 2px #F3F3F3",
              borderBottom: "solid 2px #F3F3F3",
              borderLeft: "solid 1px #F3F3F3",
              borderRight: "solid 1px #F3F3F3",
              borderRadius: "4px",
              marginTop: "0px",
              marginBottom: "4px",
              cursor: "pointer",
              display: "flex"
            },
            children: /* @__PURE__ */ jsxs(
              CategoryButton,
              {
                onClick: () => {
                  selectedCategory(category);
                },
                onKeyPress: (event2) => {
                  handleKeyPress(event2, category);
                },
                "data-cy": `show-${category.label}-filters-btn`,
                children: [
                  /* @__PURE__ */ jsx3(
                    IconBrand,
                    {
                      size: "28px",
                      icon: getIconNameFindhelp(category.label),
                      brand: "uhc"
                    },
                    `${category.label}-icon`
                  ),
                  /* @__PURE__ */ jsx3(
                    Text,
                    {
                      fontSize: "sm",
                      fontWeight: "bold",
                      color: "$core.color.brand.60",
                      "data-cy": `show-${category.label}-filters-label`,
                      style: { textAlign: "center" },
                      children: category.label
                    }
                  )
                ]
              }
            )
          },
          `${category.id}-card`
        );
      })
    }
  ) });
};

// src/QuestionTypes/Type1_dropdown_textbox/index.tsx
import React2, { useEffect, useState } from "react";
import { TextInput } from "@uhg-abyss/web/ui/TextInput";
import { SelectInput } from "@uhg-abyss/web/ui/SelectInput";
import { RadioGroup } from "@uhg-abyss/web/ui/RadioGroup";
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var Dropdown = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const [value, setValue] = useState("");
  const [radioValue, setRadioValue] = useState("");
  const [drpRequired, setDrpRequired] = useState(true);
  const [radioRequired, setRadioRequired] = useState(true);
  const [question] = useState(props);
  (_a = question == null ? void 0 : question.qstn) == null ? void 0 : _a.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });
  const options = [];
  (_b = question == null ? void 0 : question.qstn) == null ? void 0 : _b.options[0].values.forEach((val) => {
    options.push({ value: val.value, label: val.value });
  });
  const [focusOnTextBox, setFocusOnTextBox] = useState(false);
  const optionValuesArray = [];
  (_c = question == null ? void 0 : question.qstn) == null ? void 0 : _c.options.forEach((opt) => {
    optionValuesArray.push(opt.values[0].value);
  });
  useEffect(() => {
    if (value.length > 0) {
      setRadioValue("");
      setRadioRequired(false);
    }
  }, [value]);
  useEffect(() => {
    if (radioValue.trim() === (question == null ? void 0 : question.qstn.options[1].values[0].value)) {
      setDrpRequired(false);
      setRadioRequired(false);
      setValue("");
    } else if (radioValue === "") {
      setDrpRequired(true);
      setRadioRequired(false);
    } else if (radioValue.trim() === (question == null ? void 0 : question.qstn.options[2].values[0].value)) {
      setDrpRequired(false);
      setRadioRequired(false);
      setValue("");
    }
  }, [radioValue]);
  return /* @__PURE__ */ jsx4(React2.Fragment, { children: /* @__PURE__ */ jsxs2(
    RadioGroup,
    {
      label: `${question.serial}. ${(_d = question.qstn) == null ? void 0 : _d.questionText}`,
      model: `qstn-radio-${(_e = question == null ? void 0 : question.qstn) == null ? void 0 : _e.questionId}`,
      validators: { required: radioRequired },
      children: [
        /* @__PURE__ */ jsx4(
          SelectInput,
          {
            model: `qstn-${(_g = question == null ? void 0 : question.qstn) == null ? void 0 : _g.questionId}`,
            isClearable: true,
            value,
            hideLabel: true,
            label: "",
            onChange: setValue,
            isSearchable: true,
            options,
            validators: { required: drpRequired }
          },
          `dropdown-${(_h = question == null ? void 0 : question.qstn) == null ? void 0 : _h.questionId}-${question.serial}`
        ),
        (_i = question.qstn) == null ? void 0 : _i.options.map((opt, idx) => {
          var _a2, _b2, _c2, _d2;
          return idx !== 0 ? /* @__PURE__ */ jsxs2(
            "div",
            {
              style: { marginTop: "8px" },
              children: [
                /* @__PURE__ */ jsx4(
                  RadioGroup.Radio,
                  {
                    label: opt.values[0].value,
                    value: opt.values[0].value
                  },
                  opt.id
                ),
                idx === 1 && radioValue === ((_b2 = opt.values[0]) == null ? void 0 : _b2.value) ? /* @__PURE__ */ jsx4(
                  TextInput,
                  {
                    model: `text-${(_d2 = question == null ? void 0 : question.qstn) == null ? void 0 : _d2.questionId}`,
                    onFocus: () => {
                      setFocusOnTextBox(true);
                    },
                    onBlur: () => {
                      setFocusOnTextBox(false);
                    },
                    isClearable: true,
                    hideLabel: true,
                    label: "",
                    validators: {
                      required: "Please enter at least 4 characters",
                      minLength: {
                        value: 4,
                        message: "Please enter at least 4 characters"
                      }
                    }
                  },
                  `text-${(_c2 = question == null ? void 0 : question.qstn) == null ? void 0 : _c2.questionId}`
                ) : null
              ]
            },
            `radiooption-${(_a2 = question == null ? void 0 : question.qstn) == null ? void 0 : _a2.questionId}-${opt.id}`
          ) : null;
        })
      ]
    },
    `radiogrp-${(_f = question == null ? void 0 : question.qstn) == null ? void 0 : _f.questionId}-${question.serial}`
  ) });
};

// src/QuestionTypes/Type2_select_all_dropdown_textbox/index.tsx
import React3, { useEffect as useEffect2, useState as useState2 } from "react";
import { TextInput as TextInput2 } from "@uhg-abyss/web/ui/TextInput";
import { RadioGroup as RadioGroup2 } from "@uhg-abyss/web/ui/RadioGroup";
import { SelectInput as SelectInput2 } from "@uhg-abyss/web/ui/SelectInput";
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var SelectInputMulti = SelectInput2;
var MultiSelect = (props) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const [value] = useState2(["English"]);
  const [radioValue, setRadioValue] = useState2("");
  const [drpRequired, setDrpRequired] = useState2(true);
  const [txtRequired, setTxtRequired] = useState2(false);
  const [radioRequired, setRadioRequired] = useState2(false);
  const [question] = useState2(props);
  (_a = question == null ? void 0 : question.qstn) == null ? void 0 : _a.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });
  const options = [];
  const [mvalue, setMValue] = useState2([]);
  (_b = question == null ? void 0 : question.qstn) == null ? void 0 : _b.options[1].values.forEach((val) => {
    options.push({ value: val.value, label: val.value });
  });
  useEffect2(() => {
    if (radioValue.trim() === (question == null ? void 0 : question.qstn.options[1].values[0].value)) {
      setDrpRequired(false);
      setRadioRequired(false);
      setTxtRequired(true);
    } else if (radioValue === "") {
      setDrpRequired(true);
      setRadioRequired(false);
      setTxtRequired(false);
    } else if (radioValue.trim() === (question == null ? void 0 : question.qstn.options[2].values[0].value)) {
      setDrpRequired(false);
      setRadioRequired(false);
      setTxtRequired(false);
    }
  }, [radioValue]);
  return /* @__PURE__ */ jsxs3(React3.Fragment, { children: [
    /* @__PURE__ */ jsx5(
      SelectInputMulti,
      {
        label: `${question.serial}. ${(_c = question.qstn) == null ? void 0 : _c.questionText}`,
        model: `qstn-${(_d = question == null ? void 0 : question.qstn) == null ? void 0 : _d.questionId}`,
        isSearchable: true,
        value: mvalue,
        onChange: setMValue,
        options: [
          { value: "react", label: "React" },
          { value: "ng", label: "Angular" },
          { value: "svelte", label: "Svelte" },
          { value: "vue", label: "Vue" },
          { value: "alpine", label: "Alpine" },
          { value: "ember", label: "Ember" },
          { value: "stimulus", label: "Stimulus" },
          { value: "preact", label: "Preact" }
        ]
      },
      `drp-${(_e = question == null ? void 0 : question.qstn) == null ? void 0 : _e.questionId}`
    ),
    question == null ? void 0 : question.qstn.options.map((opt, index) => {
      var _a2, _b2, _c2, _d2, _e2, _f2;
      return /* @__PURE__ */ jsx5("div", { style: { marginTop: "0px" }, children: index === 0 ? null : index === 1 ? /* @__PURE__ */ jsxs3("div", { children: [
        /* @__PURE__ */ jsx5(
          RadioGroup2,
          {
            label: "",
            model: `radio-${(_a2 = question == null ? void 0 : question.qstn) == null ? void 0 : _a2.questionId}`,
            validators: { required: radioRequired },
            children: /* @__PURE__ */ jsx5(
              RadioGroup2.Radio,
              {
                label: opt.values[0].value,
                value: opt.values[0].value
              }
            )
          },
          `radio-${(_b2 = question == null ? void 0 : question.qstn) == null ? void 0 : _b2.questionId}`
        ),
        radioValue === opt.values[0].value ? /* @__PURE__ */ jsx5("div", { style: { marginTop: "5px" }, children: /* @__PURE__ */ jsx5(
          TextInput2,
          {
            label: "",
            placeholder: "",
            model: `text-${(_d2 = question == null ? void 0 : question.qstn) == null ? void 0 : _d2.questionId}`,
            isClearable: true,
            validators: { required: txtRequired }
          },
          `text-${(_c2 = question == null ? void 0 : question.qstn) == null ? void 0 : _c2.questionId}`
        ) }) : null
      ] }) : /* @__PURE__ */ jsx5(
        RadioGroup2,
        {
          label: "",
          model: `radio-${(_e2 = question == null ? void 0 : question.qstn) == null ? void 0 : _e2.values}`,
          validators: { required: radioRequired },
          children: /* @__PURE__ */ jsx5(
            RadioGroup2.Radio,
            {
              label: opt.values[0].value,
              value: opt.values[0].value
            }
          )
        },
        `radio-${(_f2 = question == null ? void 0 : question.qstn) == null ? void 0 : _f2.questionId}`
      ) }, `option-${opt.id}`);
    }),
    radioValue === "Something else please write" ? /* @__PURE__ */ jsx5(
      TextInput2,
      {
        label: "TextInput Form",
        placeholder: "Form",
        model: `text-${(_g = question == null ? void 0 : question.qstn) == null ? void 0 : _g.questionId}`,
        isClearable: true,
        hideLabel: true,
        validators: { required: txtRequired }
      },
      `text-${(_f = question == null ? void 0 : question.qstn) == null ? void 0 : _f.questionId}`
    ) : null
  ] });
};

// src/QuestionTypes/Type3_radiogroup_question/index.tsx
import { useState as useState3 } from "react";
import { RadioGroup as RadioGroup3 } from "@uhg-abyss/web/ui/RadioGroup";
import { jsx as jsx6 } from "react/jsx-runtime";
var RadioGroupQtn = (props) => {
  var _a, _b, _c, _d, _e;
  const [question] = useState3(props);
  (_a = question == null ? void 0 : question.qstn) == null ? void 0 : _a.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });
  const updatedRadio = (e) => {
    question.handleChange({
      sid: props.serial,
      qstn: props.qstn,
      value: e.target.value
    });
  };
  return /* @__PURE__ */ jsx6(
    RadioGroup3,
    {
      label: `${question.serial}. ${(_b = question.qstn) == null ? void 0 : _b.questionText}`,
      model: `qstn-${(_c = question == null ? void 0 : question.qstn) == null ? void 0 : _c.questionId}`,
      validators: { required: "Please select an option" },
      onChange: updatedRadio,
      children: /* @__PURE__ */ jsx6(RadioGroup3.Column, { children: (_e = question.qstn) == null ? void 0 : _e.options.map((option) => {
        return /* @__PURE__ */ jsx6(
          RadioGroup3.Radio,
          {
            label: option.values[0].value,
            value: option.values[0].id
          },
          option.id
        );
      }) })
    },
    `radio-${(_d = question == null ? void 0 : question.qstn) == null ? void 0 : _d.questionId}`
  );
};

// src/QuestionTypes/Type4_checkbox_question/index.tsx
import { useState as useState4 } from "react";
import { CheckboxGroup } from "@uhg-abyss/web/ui/CheckboxGroup";
import { Checkbox } from "@uhg-abyss/web/ui/Checkbox";
import { jsx as jsx7 } from "react/jsx-runtime";
var CheckboxGroupQtn = (props) => {
  var _a, _b, _c, _d, _e, _f;
  const [question] = useState4(props);
  (_a = question == null ? void 0 : question.qstn) == null ? void 0 : _a.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });
  const deselectEnableValues = [];
  (_b = question == null ? void 0 : question.qstn) == null ? void 0 : _b.options.forEach((optn) => {
    if (optn.values[0].deselectEnabled === true) {
      deselectEnableValues.push(optn.values[0].id);
    }
  });
  const updateCheckBox = (event2) => {
    let modifiedValues = [];
    if (event2.length > 0 && deselectEnableValues.indexOf(event2[event2.length - 1]) !== -1) {
      modifiedValues.push(event2[event2.length - 1]);
    } else if (event2.length > 0 && deselectEnableValues.includes(event2[0])) {
      modifiedValues = event2.slice(1, event2.length);
    } else {
      modifiedValues = event2;
    }
    question.form.setValue(`qstn-${question.qstn.questionId}`, modifiedValues);
    question.qstn.selectedValues = modifiedValues;
    question.handleChange({ qstn: props.qstn, value: modifiedValues });
  };
  return /* @__PURE__ */ jsx7(
    CheckboxGroup,
    {
      label: `${question.serial}. ${(_c = question.qstn) == null ? void 0 : _c.questionText}`,
      model: `qstn-${(_d = question == null ? void 0 : question.qstn) == null ? void 0 : _d.questionId}`,
      validators: { required: "Please select at least one option" },
      onChange: (e) => {
        updateCheckBox(e);
      },
      children: /* @__PURE__ */ jsx7(CheckboxGroup.Column, { children: (_f = question == null ? void 0 : question.qstn) == null ? void 0 : _f.options.map((_mp) => {
        return /* @__PURE__ */ jsx7(
          Checkbox,
          {
            label: _mp.values[0].value,
            value: _mp.values[0].id
          },
          _mp.id
        );
      }) })
    },
    `chck-${(_e = question == null ? void 0 : question.qstn) == null ? void 0 : _e.questionId}`
  );
};

// src/QuestionTypes/Type5_radio_textbox/index.tsx
import React6, { useState as useState5 } from "react";
import { TextInput as TextInput3 } from "@uhg-abyss/web/ui/TextInput";
import { RadioGroup as RadioGroup4 } from "@uhg-abyss/web/ui/RadioGroup";
import { jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var RadioTextBox = (props) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const [radioValue, setRadioValue] = useState5("");
  const [additionText, setAdditionText] = useState5("");
  const [question] = useState5(props);
  const [focusOnTextBox, setFocusOnTextBox] = useState5(false);
  (_a = question == null ? void 0 : question.qstn) == null ? void 0 : _a.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });
  const optionValuesArray = [];
  (_b = question == null ? void 0 : question.qstn) == null ? void 0 : _b.options.forEach((opt) => {
    optionValuesArray.push(opt.values[0].id);
  });
  const updateCheckBox = (e) => {
    if (optionValuesArray.indexOf(e) >= 0 && !focusOnTextBox) {
      setRadioValue(e);
      question.handlechange({
        qstn: props.qstn,
        value: e,
        additionText
      });
    } else if (additionText.length > 0) {
      question.handlechange({
        qstn: props.qstn,
        value: e,
        additionText
      });
    }
  };
  const handleTextInputChange = (e) => {
    var _a2;
    const newValue = e.target.value;
    setAdditionText(newValue);
    (_a2 = question.form) == null ? void 0 : _a2.setValue(`qstn-${question.qstn.questionId}`, newValue);
    updateCheckBox(radioValue);
  };
  return /* @__PURE__ */ jsx8(React6.Fragment, { children: /* @__PURE__ */ jsx8("div", { children: /* @__PURE__ */ jsx8(
    RadioGroup4,
    {
      label: `${question.serial}. ${(_d = question.qstn) == null ? void 0 : _d.questionText}`,
      model: `qstn-${(_e = question == null ? void 0 : question.qstn) == null ? void 0 : _e.questionId}`,
      validators: { required: "Please select an option" },
      onChange: (e) => {
        updateCheckBox(e.target.value);
      },
      children: /* @__PURE__ */ jsx8(RadioGroup4.Column, { children: (_g = question.qstn) == null ? void 0 : _g.options.map((opt) => {
        var _a2, _b2, _c2;
        return /* @__PURE__ */ jsxs4(
          "div",
          {
            style: { marginTop: "8px" },
            children: [
              /* @__PURE__ */ jsx8(
                RadioGroup4.Radio,
                {
                  label: opt.values[0].value,
                  value: opt.values[0].id
                },
                opt.id
              ),
              opt.values[0]["additional text"] !== void 0 && radioValue === opt.values[0].id ? /* @__PURE__ */ jsx8("div", { style: { marginTop: "4px", marginBottom: "8px" }, children: /* @__PURE__ */ jsx8(
                TextInput3,
                {
                  label: "",
                  model: `text-${(_c2 = question == null ? void 0 : question.qstn) == null ? void 0 : _c2.questionId}`,
                  hideLabel: true,
                  onFocus: () => {
                    setFocusOnTextBox(true);
                  },
                  onBlur: () => {
                    setFocusOnTextBox(false);
                  },
                  isClearable: true,
                  onChange: handleTextInputChange,
                  validators: {
                    required: "Please enter at least 4 characters",
                    minLength: {
                      value: 4,
                      message: "Please enter at least 4 characters"
                    }
                  }
                },
                `text-${(_b2 = question == null ? void 0 : question.qstn) == null ? void 0 : _b2.questionId}`
              ) }) : null
            ]
          },
          `radio-${(_a2 = question == null ? void 0 : question.qstn) == null ? void 0 : _a2.questionId}-${opt.id}`
        );
      }) })
    },
    `radiotb-${(_f = question == null ? void 0 : question.qstn) == null ? void 0 : _f.questionId}`
  ) }, (_c = question == null ? void 0 : question.qstn) == null ? void 0 : _c.questionId) });
};

// src/QuestionTypes/Type6_checkbox_textbox/index.tsx
import React7, { useState as useState6 } from "react";
import { CheckboxGroup as CheckboxGroup2 } from "@uhg-abyss/web/ui/CheckboxGroup";
import { Checkbox as Checkbox2 } from "@uhg-abyss/web/ui/Checkbox";
import { TextInput as TextInput4 } from "@uhg-abyss/web/ui/TextInput";
import { jsx as jsx9, jsxs as jsxs5 } from "react/jsx-runtime";
var CheckBoxTextBox = (props) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const [checkBoxValue, setCheckBoxValue] = useState6([""]);
  const [additionText, setAdditionText] = useState6("");
  const [question] = useState6(props);
  (_a = question == null ? void 0 : question.qstn) == null ? void 0 : _a.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });
  const deselectEnableValues = [];
  (_b = question == null ? void 0 : question.qstn) == null ? void 0 : _b.options.forEach((optn) => {
    if (optn.values[0].deselectEnabled === true) {
      deselectEnableValues.push(optn.values[0].id);
    }
  });
  const updateCheckBox = (event2) => {
    let modifiedValues = [];
    if (event2.length > 0 && deselectEnableValues.indexOf(event2[event2.length - 1]) !== -1) {
      modifiedValues.push(event2[event2.length - 1]);
    } else if (event2.length > 0 && deselectEnableValues.includes(event2[0])) {
      modifiedValues = event2.slice(1, event2.length);
    } else {
      modifiedValues = event2;
    }
    question.form.setValue(`qstn-${question.qstn.questionId}`, modifiedValues);
    question.qstn.selectedValues = modifiedValues;
    setCheckBoxValue(modifiedValues);
    question.handleChange({
      qstn: props.qstn,
      value: modifiedValues,
      additionText
    });
  };
  const handleTextInputChange = (e) => {
    const newValue = e.target.value;
    setAdditionText(newValue);
    question.form.setValue(`qstn-${question.qstn.questionId}`, newValue);
    updateCheckBox(checkBoxValue);
  };
  return /* @__PURE__ */ jsx9(React7.Fragment, { children: /* @__PURE__ */ jsx9("div", { children: /* @__PURE__ */ jsx9(
    CheckboxGroup2,
    {
      label: `${question.serial}. ${(_d = question.qstn) == null ? void 0 : _d.questionText}`,
      model: `qstn-${(_e = question == null ? void 0 : question.qstn) == null ? void 0 : _e.questionId}`,
      validators: { required: "Please select at least one option" },
      onChange: (e) => {
        updateCheckBox(e);
      },
      children: /* @__PURE__ */ jsx9(CheckboxGroup2.Column, { children: (_g = question.qstn) == null ? void 0 : _g.options.map((opt) => {
        var _a2, _b2, _c2;
        return /* @__PURE__ */ jsxs5(
          "div",
          {
            style: { marginTop: "8px" },
            children: [
              /* @__PURE__ */ jsx9(
                Checkbox2,
                {
                  label: opt.values[0].value,
                  value: opt.values[0].id
                },
                opt.id
              ),
              opt.values[0]["additional text"] !== void 0 && checkBoxValue.includes(opt.values[0].id) ? /* @__PURE__ */ jsx9("div", { style: { marginTop: "4px", marginBottom: "8px" }, children: /* @__PURE__ */ jsx9(
                TextInput4,
                {
                  model: `text-${(_c2 = question == null ? void 0 : question.qstn) == null ? void 0 : _c2.questionId}`,
                  label: opt.values[0]["additional text"],
                  isClearable: true,
                  onChange: handleTextInputChange,
                  validators: {
                    required: "Please enter at least 4 characters",
                    minLength: {
                      value: 4,
                      message: "Please enter at least 4 characters"
                    }
                  }
                },
                `text-${(_b2 = question == null ? void 0 : question.qstn) == null ? void 0 : _b2.questionId}`
              ) }) : null
            ]
          },
          `chk-${(_a2 = question == null ? void 0 : question.qstn) == null ? void 0 : _a2.questionId}-${opt.id}`
        );
      }) })
    },
    `chktb-${(_f = question == null ? void 0 : question.qstn) == null ? void 0 : _f.questionId}`
  ) }, (_c = question == null ? void 0 : question.qstn) == null ? void 0 : _c.questionId) });
};

// src/QuestionTypes/Type7_radio_dropdown/index.tsx
import React8, { useState as useState7 } from "react";
import { RadioGroup as RadioGroup5 } from "@uhg-abyss/web/ui/RadioGroup";
import { SelectInput as SelectInput3 } from "@uhg-abyss/web/ui/SelectInput";
import { jsx as jsx10, jsxs as jsxs6 } from "react/jsx-runtime";
var RadioDropdown = (props) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const [radioValue, setRadioValue] = useState7("");
  const [focusOnTextBox, setFocusOnTextBox] = useState7(false);
  const [question] = useState7(props);
  const options = [];
  (_a = question == null ? void 0 : question.qstn) == null ? void 0 : _a.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });
  (_b = question == null ? void 0 : question.qstn) == null ? void 0 : _b.options[1].values.forEach((val) => {
    options.push({ value: val.id, label: val.value });
  });
  return /* @__PURE__ */ jsx10(React8.Fragment, { children: /* @__PURE__ */ jsx10("div", { children: /* @__PURE__ */ jsx10(
    RadioGroup5,
    {
      label: `${question.serial}. ${(_d = question.qstn) == null ? void 0 : _d.questionText}`,
      model: `qstn-${(_e = question == null ? void 0 : question.qstn) == null ? void 0 : _e.questionId}`,
      validators: { required: "Please select an option" },
      onChange: (e) => {
        if (!focusOnTextBox) {
          setRadioValue(e.target.value);
        }
      },
      children: (_g = question.qstn) == null ? void 0 : _g.options.map((option, idx) => {
        var _a2, _b2;
        return /* @__PURE__ */ jsx10(
          "div",
          {
            style: { paddingTop: "5px" },
            children: idx !== 1 ? /* @__PURE__ */ jsx10(
              RadioGroup5.Radio,
              {
                label: option.values[0].value,
                value: option.values[0].id
              },
              `type-7-opt-${question.qstn.questionId}-${option.id}`
            ) : /* @__PURE__ */ jsxs6("div", { children: [
              /* @__PURE__ */ jsx10(RadioGroup5.Radio, { label: "Yes", value: "Yes" }, option.id),
              radioValue === "Yes" ? /* @__PURE__ */ jsx10(
                SelectInput3,
                {
                  label: "",
                  placeholder: "Please select",
                  model: `text-${(_b2 = question == null ? void 0 : question.qstn) == null ? void 0 : _b2.questionId}`,
                  isClearable: true,
                  hideLabel: true,
                  isSearchable: true,
                  options,
                  onFocus: () => {
                    setFocusOnTextBox(true);
                  },
                  onBlur: () => {
                    setFocusOnTextBox(false);
                  },
                  validators: {
                    required: "Please select an option from the dropdown"
                  }
                },
                `type-7-opt-${question.qstn.questionId}-${option.id}`
              ) : null
            ] })
          },
          `div-type7-${(_a2 = question == null ? void 0 : question.qstn) == null ? void 0 : _a2.questionId}-${question.serial}-${option.id}`
        );
      })
    },
    `type7-${(_f = question == null ? void 0 : question.qstn) == null ? void 0 : _f.questionId}-${question.serial}`
  ) }, (_c = question == null ? void 0 : question.qstn) == null ? void 0 : _c.questionId) });
};

// src/QuestionUI/index.tsx
import React9, { useState as useState8, useCallback } from "react";
import { Icon } from "@uhg-abyss/web/ui/Icon";
import { Text as Text2 } from "@uhg-abyss/web/ui/Text";
import { Heading } from "@uhg-abyss/web/ui/Heading";
import { Button as Button2 } from "@uhg-abyss/web/ui/Button";
import { ProgressBar } from "@uhg-abyss/web/ui/ProgressBar";
import { FormProvider } from "@uhg-abyss/web/ui/FormProvider";
import { useForm } from "@uhg-abyss/web/hooks/useForm";
import { Layout as Layout2 } from "@uhg-abyss/web/ui/Layout";
import { Grid } from "@uhg-abyss/web/ui/Grid";
import { ModalDialog } from "@uhg-abyss/web/ui/ModalDialog";
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var SingleQuestionPerPageUI = ({
  questions = [],
  submitResponse,
  closeQuiz,
  modalStatus
}) => {
  const [landing, setLanding] = useState8(true);
  const [complete, setComplete] = useState8(false);
  const [exitModal, setExitModal] = useState8(modalStatus);
  const [isModalOpen, setIsModalOpen] = useState8(false);
  const [answers, setAnswers] = useState8(/* @__PURE__ */ new Map());
  const [currentNumberOfQuestion, setCurrentNumberOfQuestion] = useState8(-1);
  const [showSubmit, setShowSubmit] = useState8(false);
  const updateAnswers = (answer) => {
    const sval = answer.value;
    if (Array.isArray(sval)) {
      const options = sval.map((opt) => {
        const optionData = answer.qstn.options.find((o) => {
          return o.values[0].id === opt;
        });
        let freetext = "";
        if ((optionData == null ? void 0 : optionData.values[0].value) === "Other") {
          freetext = answer.additionText;
        }
        return {
          optionId: optionData == null ? void 0 : optionData.id,
          text: optionData == null ? void 0 : optionData.values[0].value,
          freeTextValue: (freetext == null ? void 0 : freetext.length) > 0 ? freetext : null,
          optionValueId: optionData == null ? void 0 : optionData.values[0].id
        };
      });
      answer.option = options;
    } else {
      const optionData = answer.qstn.options.find((o) => {
        return o.values[0].id === answer.value;
      });
      let freetext = "";
      if ((optionData == null ? void 0 : optionData.values[0].value) === "Other") {
        freetext = answer.additionText;
      }
      const options = {
        optionId: optionData == null ? void 0 : optionData.id,
        text: optionData == null ? void 0 : optionData.values[0].value,
        freeTextValue: (freetext == null ? void 0 : freetext.length) > 0 ? freetext : null,
        optionValueId: optionData == null ? void 0 : optionData.values[0].id
      };
      answer.option = [options];
    }
    answers.set(`question-${answer.qstn.questionId}`, answer);
    setAnswers(answers);
  };
  const checkContinue = (qid) => {
    return !answers.has(`question-${qid}`);
  };
  const updatedRadio = (e) => {
    updateAnswers(e);
  };
  const handleDropdownChange = (e) => {
    updateAnswers(e);
  };
  const handleCheckGroupChange = (e) => {
    updateAnswers(e);
  };
  const handleRadioTextBoxChange = (e) => {
    updateAnswers(e);
  };
  const handleCheckBoxTextBoxChange = (e) => {
    updateAnswers(e);
  };
  const handleRadioDropdownChange = (e) => {
    updateAnswers(e);
  };
  const getStarted = () => {
    setLanding(false);
    setCurrentNumberOfQuestion(0);
  };
  const goToNextQuestion = () => {
    if (currentNumberOfQuestion === questions.length - 2) {
      setShowSubmit(true);
    }
    if (!(currentNumberOfQuestion === questions.length - 1)) {
      setCurrentNumberOfQuestion(currentNumberOfQuestion + 1);
    }
  };
  const goToPreviousQuestion = () => {
    setCurrentNumberOfQuestion(currentNumberOfQuestion - 1);
    setShowSubmit(false);
    if (currentNumberOfQuestion < 1) {
      setLanding(true);
    }
  };
  const submitAnswers = () => {
    submitResponse(answers);
    setComplete(true);
  };
  const exitModalFunc = () => {
    setIsModalOpen(true);
  };
  const noFinishFunc = () => {
    closeQuiz("No");
    setIsModalOpen(false);
  };
  const leaveFunc = () => {
    closeQuiz("Yes");
  };
  const form = useForm({
    defaultValues: {}
  });
  const loadUI = useCallback(
    (questionTypeId, qstn, index) => {
      switch (questionTypeId) {
        case "1":
          return /* @__PURE__ */ jsx11(
            Dropdown,
            {
              serial: index + 1,
              qstn,
              handleChange: handleDropdownChange
            },
            index
          );
        case "3":
          return /* @__PURE__ */ jsx11(
            RadioGroupQtn,
            {
              serial: index + 1,
              qstn,
              handleChange: updatedRadio
            },
            index
          );
        case "4":
          return /* @__PURE__ */ jsx11(
            CheckboxGroupQtn,
            {
              serial: index + 1,
              qstn,
              form,
              handleChange: handleCheckGroupChange
            },
            index
          );
        case "5":
          return /* @__PURE__ */ jsx11(
            RadioTextBox,
            {
              serial: index + 1,
              qstn,
              handlechange: handleRadioTextBoxChange
            },
            index
          );
        case "6":
          return /* @__PURE__ */ jsx11(
            CheckBoxTextBox,
            {
              serial: index + 1,
              qstn,
              form,
              handleChange: handleCheckBoxTextBoxChange
            },
            index
          );
        case "7":
          return /* @__PURE__ */ jsx11(
            RadioDropdown,
            {
              serial: index + 1,
              qstn,
              handleChange: handleRadioDropdownChange
            },
            index
          );
        default:
          return null;
      }
    },
    [questions]
  );
  return /* @__PURE__ */ jsxs7(React9.Fragment, { children: [
    /* @__PURE__ */ jsx11("meta", { name: "viewport", content: "width=device-width, initial-scale=0.75" }),
    /* @__PURE__ */ jsxs7(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          paddingLeft: "40px",
          paddingRight: "40px",
          paddingTop: "40px"
        },
        children: [
          /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(Icon, { size: "60px", title: "money", onClick: leaveFunc, children: /* @__PURE__ */ jsx11(
            "svg",
            {
              width: "19",
              height: "32",
              viewBox: "0 0 19 32",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /* @__PURE__ */ jsx11(
                "path",
                {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M8.40518 30.963C7.30014 30.9659 6.20238 30.786 5.15714 30.4308C6.58923 31.3773 8.26958 31.8883 9.9912 31.9007C15.0118 31.9007 18.5571 27.9307 18.5571 21.12V0L16.6981 0.877861V20.7743C16.6981 27.4516 13.2945 30.963 8.40518 30.963ZM6.28359 29.0173C5.29017 29.0173 4.16199 28.7778 3.03554 28.4064C4.37795 29.3938 5.98815 29.979 7.57417 29.979C11.8709 29.979 14.9583 26.8937 14.9583 20.8548V1.54011L13.1321 2.39572V20.6922C13.1321 26.4642 10.3937 29.0173 6.28359 29.0173ZM1.74496 26.6011C2.622 26.8856 3.53512 27.0463 4.45742 27.0785C7.65364 27.0785 9.61456 25.3502 9.61456 20.8017V3.93583L11.4131 3.08021V20.5348C11.4131 25.6428 9.05134 27.9564 5.6668 27.9564C4.24365 27.9496 2.86348 27.4726 1.74496 26.6011ZM7.92316 4.62888V21.2809C7.92316 24.2327 6.4719 25.9936 4.05487 25.9936C1.63784 25.9936 0 24.2652 0 21.6847V8.16599L7.92316 4.62888Z",
                  fill: "#002677"
                }
              )
            }
          ) }) }),
          /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(Button2, { variant: "text", onClick: exitModalFunc, children: "Close" }) })
        ]
      }
    ),
    /* @__PURE__ */ jsxs7(Grid, { children: [
      /* @__PURE__ */ jsx11(Grid.Col, { span: { xs: "0%", md: "20%" } }),
      /* @__PURE__ */ jsx11(Grid.Col, { span: { xs: "100%", md: "60%" }, children: /* @__PURE__ */ jsx11(Layout2.Group, { alignLayout: "center", children: /* @__PURE__ */ jsx11("div", { style: { maxWidth: "100%" }, children: /* @__PURE__ */ jsxs7(FormProvider, { state: form, onSubmit: () => {
      }, children: [
        /* @__PURE__ */ jsxs7(
          ModalDialog,
          {
            header: "Are you sure you want to leave?",
            isOpen: isModalOpen,
            onClose: () => setIsModalOpen(false),
            css: {
              "abyss-modal-base-header": { flex: 1, textAlign: "center" }
            },
            children: [
              /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(
                Layout2.Group,
                {
                  alignLayout: "center",
                  style: { marginTop: "-2px", marginBottom: "9px" },
                  children: /* @__PURE__ */ jsx11("label", { children: "Yours answers will not be saved." })
                }
              ) }),
              /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(
                Layout2.Group,
                {
                  alignLayout: "center",
                  style: { paddingBottom: "19px" },
                  children: /* @__PURE__ */ jsxs7(Grid, { children: [
                    /* @__PURE__ */ jsx11(Grid.Col, { span: { xs: 12, md: 6, lg: 6 }, children: /* @__PURE__ */ jsx11(
                      Button2,
                      {
                        variant: "outline",
                        style: { width: "100%", marginRight: "6px" },
                        onClick: leaveFunc,
                        children: "Yes, leave"
                      }
                    ) }),
                    /* @__PURE__ */ jsx11(Grid.Col, { span: { xs: 12, md: 6, lg: 6 }, children: /* @__PURE__ */ jsx11(
                      Button2,
                      {
                        type: "submit",
                        style: { width: "100%" },
                        onClick: noFinishFunc,
                        children: "No, finish"
                      }
                    ) })
                  ] })
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ jsxs7(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingBottom: "20px",
              paddingLeft: "40px",
              paddingRight: "40px"
            },
            children: [
              /* @__PURE__ */ jsxs7("div", { style: { width: "450px" }, children: [
                /* @__PURE__ */ jsx11("br", {}),
                /* @__PURE__ */ jsx11(Heading, { level: 3, size: "lg", children: "Helping you find resources" }),
                /* @__PURE__ */ jsx11("br", {}),
                /* @__PURE__ */ jsx11("br", {}),
                questions && !complete && /* @__PURE__ */ jsx11("div", { style: { marginBottom: "24px" }, children: /* @__PURE__ */ jsx11(
                  ProgressBar,
                  {
                    label: `${currentNumberOfQuestion + 1} of ${questions.length} Questions`,
                    percentage: (currentNumberOfQuestion + 1) / questions.length * 100
                  }
                ) }),
                complete && /* @__PURE__ */ jsx11("div", { style: { marginBottom: "24px" }, children: /* @__PURE__ */ jsx11(ProgressBar, { label: "Complete", percentage: 100 }) })
              ] }),
              landing && /* @__PURE__ */ jsxs7("div", { style: { width: "450px" }, children: [
                /* @__PURE__ */ jsxs7(Text2, { children: [
                  " ",
                  /* @__PURE__ */ jsx11("br", {})
                ] }),
                /* @__PURE__ */ jsx11("label", { children: "If you're in need, we'll help connect you to the right resources. Simply answer a few questions to find the right resources." }),
                /* @__PURE__ */ jsx11("br", {}),
                /* @__PURE__ */ jsx11("br", {}),
                /* @__PURE__ */ jsx11("br", {}),
                /* @__PURE__ */ jsx11(Button2, { style: { width: "100%" }, onClick: getStarted, children: "Get started" })
              ] }),
              !landing && !complete && (questions == null ? void 0 : questions.length) > 0 && (questions == null ? void 0 : questions.map((question, index) => {
                return /* @__PURE__ */ jsx11("div", { children: currentNumberOfQuestion === index && /* @__PURE__ */ jsxs7("div", { children: [
                  loadUI(question == null ? void 0 : question.questionTypeId, question, index),
                  /* @__PURE__ */ jsx11("br", {}),
                  /* @__PURE__ */ jsx11("br", {}),
                  /* @__PURE__ */ jsx11("div", { style: { width: "450px" }, children: /* @__PURE__ */ jsxs7("div", { style: { display: "flex", justifyContent: "center" }, children: [
                    /* @__PURE__ */ jsx11(
                      Button2,
                      {
                        variant: "outline",
                        style: { width: "48%" },
                        onClick: goToPreviousQuestion,
                        children: "Back"
                      }
                    ),
                    /* @__PURE__ */ jsx11(
                      Button2,
                      {
                        style: { width: "48%", marginLeft: "15px" },
                        onClick: showSubmit ? submitAnswers : goToNextQuestion,
                        isDisabled: checkContinue(question.questionId),
                        children: showSubmit ? "Submit" : "Continue"
                      }
                    )
                  ] }) })
                ] }) }, question.questionId);
              }))
            ]
          }
        )
      ] }) }) }) }),
      /* @__PURE__ */ jsx11(Grid.Col, { span: { xs: "0%", md: "20%" } })
    ] })
  ] });
};

// src/CboCardUniteUs/CboCardUniteUs.tsx
import React10, {
  useState as useState9,
  useEffect as useEffect3,
  useMemo,
  useCallback as useCallback2
} from "react";
import { Text as Text4 } from "@uhg-abyss/web/ui/Text";
import { Heading as Heading2 } from "@uhg-abyss/web/ui/Heading";
import { IconSymbol } from "@uhg-abyss/web/ui/IconSymbol";
import { Flex } from "@uhg-abyss/web/ui/Flex";
import { Layout as Layout3 } from "@uhg-abyss/web/ui/Layout";
import { Checkbox as Checkbox3 } from "@uhg-abyss/web/ui/Checkbox";

// src/CboCardUniteUs/CboCardUniteUsNextSteps.tsx
import { Text as Text3 } from "@uhg-abyss/web/ui/Text";
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var CboCardUniteUsNextSteps = ({
  closestOfficeAddressText,
  closestOfficeEmail,
  closestOfficeWebsite,
  closestOfficePhone
}) => {
  const hasNextSteps = closestOfficeAddressText || closestOfficeEmail || closestOfficeWebsite || closestOfficePhone && closestOfficePhone.length > 0;
  return /* @__PURE__ */ jsxs8("div", { children: [
    /* @__PURE__ */ jsx12(Text3, { color: "black", fontWeight: "bold", fontSize: "md", children: "Next steps:" }),
    hasNextSteps ? /* @__PURE__ */ jsxs8("ul", { children: [
      closestOfficeAddressText && /* @__PURE__ */ jsx12("li", { children: /* @__PURE__ */ jsxs8(Text3, { color: "black", fontWeight: "regular", fontSize: "md", children: [
        "Go to ",
        closestOfficeAddressText,
        " to schedule an appointment."
      ] }) }),
      closestOfficeEmail && /* @__PURE__ */ jsx12("li", { children: /* @__PURE__ */ jsxs8("span", { children: [
        "Write an email to",
        " ",
        /* @__PURE__ */ jsx12("a", { href: `mailto:${closestOfficeEmail}`, children: closestOfficeEmail }),
        " ",
        "to schedule an appointment."
      ] }) }),
      closestOfficeWebsite && /* @__PURE__ */ jsx12("li", { children: /* @__PURE__ */ jsxs8("span", { children: [
        "Go to the website",
        " ",
        /* @__PURE__ */ jsx12("a", { href: closestOfficeWebsite, children: closestOfficeWebsite }),
        " to get more info."
      ] }) }),
      closestOfficePhone && closestOfficePhone.length > 0 && /* @__PURE__ */ jsx12("li", { children: /* @__PURE__ */ jsxs8("span", { children: [
        "Call",
        " ",
        Array.isArray(closestOfficePhone) ? closestOfficePhone.map((phone) => {
          return phone.phone_number;
        }).join(", ") : closestOfficePhone,
        " ",
        "to get services."
      ] }) })
    ] }) : /* @__PURE__ */ jsx12("div", { children: "No next steps" })
  ] });
};

// src/CboCardUniteUs/CboCardUniteUs.tsx
import { styled as styled2 } from "@uhg-abyss/web/tools/styled";
import { Popover } from "@uhg-abyss/web/ui/Popover";

// ../../node_modules/dompurify/dist/purify.es.mjs
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ;
      else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
var entries = Object.entries;
var setPrototypeOf = Object.setPrototypeOf;
var isFrozen = Object.isFrozen;
var getPrototypeOf = Object.getPrototypeOf;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var freeze = Object.freeze;
var seal = Object.seal;
var create = Object.create;
var _ref = typeof Reflect !== "undefined" && Reflect;
var apply = _ref.apply;
var construct = _ref.construct;
if (!freeze) {
  freeze = function freeze2(x) {
    return x;
  };
}
if (!seal) {
  seal = function seal2(x) {
    return x;
  };
}
if (!apply) {
  apply = function apply2(func, thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return func.apply(thisArg, args);
  };
}
if (!construct) {
  construct = function construct2(Func) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return new Func(...args);
  };
}
var arrayForEach = unapply(Array.prototype.forEach);
var arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
var arrayPop = unapply(Array.prototype.pop);
var arrayPush = unapply(Array.prototype.push);
var arraySplice = unapply(Array.prototype.splice);
var arrayIsArray = Array.isArray;
var stringToLowerCase = unapply(String.prototype.toLowerCase);
var stringToString = unapply(String.prototype.toString);
var stringMatch = unapply(String.prototype.match);
var stringReplace = unapply(String.prototype.replace);
var stringIndexOf = unapply(String.prototype.indexOf);
var stringTrim = unapply(String.prototype.trim);
var numberToString = unapply(Number.prototype.toString);
var booleanToString = unapply(Boolean.prototype.toString);
var bigintToString = typeof BigInt === "undefined" ? null : unapply(BigInt.prototype.toString);
var symbolToString = typeof Symbol === "undefined" ? null : unapply(Symbol.prototype.toString);
var objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
var objectToString = unapply(Object.prototype.toString);
var regExpTest = unapply(RegExp.prototype.test);
var typeErrorCreate = unconstruct(TypeError);
function unapply(func) {
  return function(thisArg) {
    if (thisArg instanceof RegExp) {
      thisArg.lastIndex = 0;
    }
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return apply(func, thisArg, args);
  };
}
function unconstruct(Func) {
  return function() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return construct(Func, args);
  };
}
function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    setPrototypeOf(set, null);
  }
  if (!arrayIsArray(array)) {
    return set;
  }
  let l = array.length;
  while (l--) {
    let element = array[l];
    if (typeof element === "string") {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}
function cleanArray(array) {
  for (let index = 0; index < array.length; index++) {
    const isPropertyExist = objectHasOwnProperty(array, index);
    if (!isPropertyExist) {
      array[index] = null;
    }
  }
  return array;
}
function clone(object) {
  const newObject = create(null);
  for (const _ref2 of entries(object)) {
    var _ref3 = _slicedToArray(_ref2, 2);
    const property = _ref3[0];
    const value = _ref3[1];
    const isPropertyExist = objectHasOwnProperty(object, property);
    if (isPropertyExist) {
      if (arrayIsArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === "object" && value.constructor === Object) {
        newObject[property] = clone(value);
      } else {
        newObject[property] = value;
      }
    }
  }
  return newObject;
}
function stringifyValue(value) {
  switch (typeof value) {
    case "string": {
      return value;
    }
    case "number": {
      return numberToString(value);
    }
    case "boolean": {
      return booleanToString(value);
    }
    case "bigint": {
      return bigintToString ? bigintToString(value) : "0";
    }
    case "symbol": {
      return symbolToString ? symbolToString(value) : "Symbol()";
    }
    case "undefined": {
      return objectToString(value);
    }
    case "function":
    case "object": {
      if (value === null) {
        return objectToString(value);
      }
      const valueAsRecord = value;
      const valueToString = lookupGetter(valueAsRecord, "toString");
      if (typeof valueToString === "function") {
        const stringified = valueToString(valueAsRecord);
        return typeof stringified === "string" ? stringified : objectToString(stringified);
      }
      return objectToString(value);
    }
    default: {
      return objectToString(value);
    }
  }
}
function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === "function") {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}
function isRegex(value) {
  try {
    regExpTest(value, "");
    return true;
  } catch (_unused) {
    return false;
  }
}
var html$1 = freeze(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]);
var svg$1 = freeze(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]);
var svgFilters = freeze(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]);
var svgDisallowed = freeze(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]);
var mathMl$1 = freeze(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]);
var mathMlDisallowed = freeze(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]);
var text = freeze(["#text"]);
var html = freeze(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]);
var svg = freeze(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dominant-baseline", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-orientation", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]);
var mathMl = freeze(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]);
var xml = freeze(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]);
var MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
var ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
var TMPLIT_EXPR = seal(/\${[\w\W]*/g);
var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/);
var ARIA_ATTR = seal(/^aria-[\-\w]+$/);
var IS_ALLOWED_URI = seal(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
);
var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
var ATTR_WHITESPACE = seal(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
);
var DOCTYPE_NAME = seal(/^html$/i);
var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var ELEMENT_MARKUP_PROBE = seal(/<[/\w!]/g);
var COMMENT_MARKUP_PROBE = seal(/<[/\w]/g);
var FALLBACK_TAG_CLOSE = seal(/<\/no(script|embed|frames)/i);
var SELF_CLOSING_TAG = seal(/\/>/i);
var NODE_TYPE = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
};
var getGlobal = function getGlobal2() {
  return typeof window === "undefined" ? null : window;
};
var _createTrustedTypesPolicy = function _createTrustedTypesPolicy2(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") {
    return null;
  }
  let suffix = null;
  const ATTR_NAME = "data-tt-policy-suffix";
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = "dompurify" + (suffix ? "#" + suffix : "");
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html2) {
        return html2;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    console.warn("TrustedTypes policy " + policyName + " could not be created.");
    return null;
  }
};
var _createHooksMap = function _createHooksMap2() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
var _resolveSetOption = function _resolveSetOption2(cfg, key, fallback, options) {
  return objectHasOwnProperty(cfg, key) && arrayIsArray(cfg[key]) ? addToSet(options.base ? clone(options.base) : {}, cfg[key], options.transform) : fallback;
};
function createDOMPurify() {
  let window2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
  const DOMPurify = (root) => createDOMPurify(root);
  DOMPurify.version = "3.4.12";
  DOMPurify.removed = [];
  if (!window2 || !window2.document || window2.document.nodeType !== NODE_TYPE.document || !window2.Element) {
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let document2 = window2.document;
  const originalDocument = document2;
  const currentScript = originalDocument.currentScript;
  window2.DocumentFragment;
  const HTMLTemplateElement = window2.HTMLTemplateElement, Node = window2.Node, Element = window2.Element, NodeFilter = window2.NodeFilter, _window$NamedNodeMap = window2.NamedNodeMap;
  _window$NamedNodeMap === void 0 ? window2.NamedNodeMap || window2.MozNamedAttrMap : _window$NamedNodeMap;
  window2.HTMLFormElement;
  const DOMParser = window2.DOMParser, trustedTypes = window2.trustedTypes;
  const ElementPrototype = Element.prototype;
  const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
  const remove = lookupGetter(ElementPrototype, "remove");
  const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
  const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
  const getParentNode = lookupGetter(ElementPrototype, "parentNode");
  const getShadowRoot = lookupGetter(ElementPrototype, "shadowRoot");
  const getAttributes = lookupGetter(ElementPrototype, "attributes");
  const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeType") : null;
  const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeName") : null;
  if (typeof HTMLTemplateElement === "function") {
    const template = document2.createElement("template");
    if (template.content && template.content.ownerDocument) {
      document2 = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = "";
  let defaultTrustedTypesPolicy;
  let defaultTrustedTypesPolicyResolved = false;
  let IN_TRUSTED_TYPES_POLICY = 0;
  const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy2() {
    if (IN_TRUSTED_TYPES_POLICY > 0) {
      throw typeErrorCreate('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
    }
  };
  const _createTrustedHTML = function _createTrustedHTML2(html2) {
    _assertNotInTrustedTypesPolicy();
    IN_TRUSTED_TYPES_POLICY++;
    try {
      return trustedTypesPolicy.createHTML(html2);
    } finally {
      IN_TRUSTED_TYPES_POLICY--;
    }
  };
  const _createTrustedScriptURL = function _createTrustedScriptURL2(scriptUrl) {
    _assertNotInTrustedTypesPolicy();
    IN_TRUSTED_TYPES_POLICY++;
    try {
      return trustedTypesPolicy.createScriptURL(scriptUrl);
    } finally {
      IN_TRUSTED_TYPES_POLICY--;
    }
  };
  const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy2() {
    if (!defaultTrustedTypesPolicyResolved) {
      defaultTrustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      defaultTrustedTypesPolicyResolved = true;
    }
    return defaultTrustedTypesPolicy;
  };
  const _document = document2, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
  const importNode = originalDocument.importNode;
  let hooks = _createHooksMap();
  DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== void 0;
  const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
  let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  let FORBID_TAGS = null;
  let FORBID_ATTR = null;
  const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
    tagCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    }
  }));
  let ALLOW_ARIA_ATTR = true;
  let ALLOW_DATA_ATTR = true;
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  let SAFE_FOR_TEMPLATES = false;
  let SAFE_FOR_XML = true;
  let WHOLE_DOCUMENT = false;
  let SET_CONFIG = false;
  let SET_CONFIG_ALLOWED_TAGS = null;
  let SET_CONFIG_ALLOWED_ATTR = null;
  let FORCE_BODY = false;
  let RETURN_DOM = false;
  let RETURN_DOM_FRAGMENT = false;
  let RETURN_TRUSTED_TYPE = false;
  let SANITIZE_DOM = true;
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
  let KEEP_CONTENT = true;
  let IN_PLACE = false;
  let USE_PROFILES = {};
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ["audio", "video", "img", "source", "image", "track"]);
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]);
  const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
  const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
  const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = freeze(["mi", "mo", "mn", "ms", "mtext"]);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
  const DEFAULT_HTML_INTEGRATION_POINTS = freeze(["annotation-xml"]);
  let HTML_INTEGRATION_POINTS = addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ["title", "style", "font", "a", "script"]);
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ["application/xhtml+xml", "text/html"];
  const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
  let transformCaseFunc = null;
  let CONFIG = null;
  const formElement = document2.createElement("form");
  const isRegexOrFunction = function isRegexOrFunction2(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  const _parseConfig = function _parseConfig2() {
    let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    if (!cfg || typeof cfg !== "object") {
      cfg = {};
    }
    cfg = clone(cfg);
    PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
    ALLOWED_TAGS = _resolveSetOption(cfg, "ALLOWED_TAGS", DEFAULT_ALLOWED_TAGS, {
      transform: transformCaseFunc
    });
    ALLOWED_ATTR = _resolveSetOption(cfg, "ALLOWED_ATTR", DEFAULT_ALLOWED_ATTR, {
      transform: transformCaseFunc
    });
    ALLOWED_NAMESPACES = _resolveSetOption(cfg, "ALLOWED_NAMESPACES", DEFAULT_ALLOWED_NAMESPACES, {
      transform: stringToString
    });
    URI_SAFE_ATTRIBUTES = _resolveSetOption(cfg, "ADD_URI_SAFE_ATTR", DEFAULT_URI_SAFE_ATTRIBUTES, {
      transform: transformCaseFunc,
      base: DEFAULT_URI_SAFE_ATTRIBUTES
    });
    DATA_URI_TAGS = _resolveSetOption(cfg, "ADD_DATA_URI_TAGS", DEFAULT_DATA_URI_TAGS, {
      transform: transformCaseFunc,
      base: DEFAULT_DATA_URI_TAGS
    });
    FORBID_CONTENTS = _resolveSetOption(cfg, "FORBID_CONTENTS", DEFAULT_FORBID_CONTENTS, {
      transform: transformCaseFunc
    });
    FORBID_TAGS = _resolveSetOption(cfg, "FORBID_TAGS", clone({}), {
      transform: transformCaseFunc
    });
    FORBID_ATTR = _resolveSetOption(cfg, "FORBID_ATTR", clone({}), {
      transform: transformCaseFunc
    });
    USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === "object" ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
    RETURN_DOM = cfg.RETURN_DOM || false;
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
    FORCE_BODY = cfg.FORCE_BODY || false;
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
    IN_PLACE = cfg.IN_PLACE || false;
    IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI;
    NAMESPACE = typeof cfg.NAMESPACE === "string" ? cfg.NAMESPACE : HTML_NAMESPACE;
    MATHML_TEXT_INTEGRATION_POINTS = objectHasOwnProperty(cfg, "MATHML_TEXT_INTEGRATION_POINTS") && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === "object" ? clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
    HTML_INTEGRATION_POINTS = objectHasOwnProperty(cfg, "HTML_INTEGRATION_POINTS") && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === "object" ? clone(cfg.HTML_INTEGRATION_POINTS) : addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
    const customElementHandling = objectHasOwnProperty(cfg, "CUSTOM_ELEMENT_HANDLING") && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === "object" ? clone(cfg.CUSTOM_ELEMENT_HANDLING) : create(null);
    CUSTOM_ELEMENT_HANDLING = create(null);
    if (objectHasOwnProperty(customElementHandling, "tagNameCheck") && isRegexOrFunction(customElementHandling.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck;
    }
    if (objectHasOwnProperty(customElementHandling, "attributeNameCheck") && isRegexOrFunction(customElementHandling.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck;
    }
    if (objectHasOwnProperty(customElementHandling, "allowCustomizedBuiltInElements") && typeof customElementHandling.allowCustomizedBuiltInElements === "boolean") {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements;
    }
    seal(CUSTOM_ELEMENT_HANDLING);
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, text);
      ALLOWED_ATTR = create(null);
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    EXTRA_ELEMENT_HANDLING.tagCheck = null;
    EXTRA_ELEMENT_HANDLING.attributeCheck = null;
    if (objectHasOwnProperty(cfg, "ADD_TAGS")) {
      if (typeof cfg.ADD_TAGS === "function") {
        EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
      } else if (arrayIsArray(cfg.ADD_TAGS)) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
    }
    if (objectHasOwnProperty(cfg, "ADD_ATTR")) {
      if (typeof cfg.ADD_ATTR === "function") {
        EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
      } else if (arrayIsArray(cfg.ADD_ATTR)) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
    }
    if (objectHasOwnProperty(cfg, "ADD_URI_SAFE_ATTR") && arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (objectHasOwnProperty(cfg, "FORBID_CONTENTS") && arrayIsArray(cfg.FORBID_CONTENTS)) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    if (objectHasOwnProperty(cfg, "ADD_FORBID_CONTENTS") && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
    }
    if (KEEP_CONTENT) {
      ALLOWED_TAGS["#text"] = true;
    }
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ["html", "head", "body"]);
    }
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ["tbody"]);
      delete FORBID_TAGS.tbody;
    }
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      const previousTrustedTypesPolicy = trustedTypesPolicy;
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      try {
        emptyHTML = _createTrustedHTML("");
      } catch (error) {
        trustedTypesPolicy = previousTrustedTypesPolicy;
        throw error;
      }
    } else if (cfg.TRUSTED_TYPES_POLICY === null) {
      trustedTypesPolicy = void 0;
      emptyHTML = "";
    } else {
      if (trustedTypesPolicy === void 0) {
        trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
      }
      if (trustedTypesPolicy && typeof emptyHTML === "string") {
        emptyHTML = _createTrustedHTML("");
      }
    }
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  const _checkSvgNamespace = function _checkSvgNamespace2(tagName, parent, parentTagName) {
    if (parent.namespaceURI === HTML_NAMESPACE) {
      return tagName === "svg";
    }
    if (parent.namespaceURI === MATHML_NAMESPACE) {
      return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
    }
    return Boolean(ALL_SVG_TAGS[tagName]);
  };
  const _checkMathMlNamespace = function _checkMathMlNamespace2(tagName, parent, parentTagName) {
    if (parent.namespaceURI === HTML_NAMESPACE) {
      return tagName === "math";
    }
    if (parent.namespaceURI === SVG_NAMESPACE) {
      return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
    }
    return Boolean(ALL_MATHML_TAGS[tagName]);
  };
  const _checkHtmlNamespace = function _checkHtmlNamespace2(tagName, parent, parentTagName) {
    if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
      return false;
    }
    if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
      return false;
    }
    return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
  };
  const _checkValidNamespace = function _checkValidNamespace2(element) {
    let parent = getParentNode(element);
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: "template"
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      return _checkSvgNamespace(tagName, parent, parentTagName);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      return _checkMathMlNamespace(tagName, parent, parentTagName);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      return _checkHtmlNamespace(tagName, parent, parentTagName);
    }
    if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    return false;
  };
  const _forceRemove = function _forceRemove2(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      getParentNode(node).removeChild(node);
    } catch (_) {
      remove(node);
      if (!getParentNode(node)) {
        throw typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
      }
    }
  };
  const _neutralizeRoot = function _neutralizeRoot2(root) {
    _neutralizeSubtree(root);
    const childNodes = getChildNodes(root);
    if (childNodes) {
      const snapshot = [];
      arrayForEach(childNodes, (child) => {
        arrayPush(snapshot, child);
      });
      arrayForEach(snapshot, (child) => {
        try {
          remove(child);
        } catch (_) {
        }
      });
    }
    const attributes = getAttributes(root);
    if (attributes) {
      for (let i = attributes.length - 1; i >= 0; --i) {
        const attribute = attributes[i];
        const name = attribute && attribute.name;
        if (typeof name === "string") {
          try {
            root.removeAttribute(name);
          } catch (_) {
          }
        }
      }
    }
  };
  const _removeAttribute = function _removeAttribute2(name, element) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: element.getAttributeNode(name),
        from: element
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: element
      });
    }
    element.removeAttribute(name);
    if (name === "is") {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {
        }
      } else {
        try {
          element.setAttribute(name, "");
        } catch (_) {
        }
      }
    }
  };
  const _stripDisallowedAttributes = function _stripDisallowedAttributes2(element) {
    const attributes = getAttributes(element);
    if (!attributes) {
      return;
    }
    for (let i = attributes.length - 1; i >= 0; --i) {
      const attribute = attributes[i];
      const name = attribute && attribute.name;
      if (typeof name !== "string" || ALLOWED_ATTR[transformCaseFunc(name)]) {
        continue;
      }
      try {
        element.removeAttribute(name);
      } catch (_) {
      }
    }
  };
  const _neutralizeSubtree = function _neutralizeSubtree2(root) {
    const stack = [root];
    while (stack.length > 0) {
      const node = stack.pop();
      const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
      if (nodeType === NODE_TYPE.element) {
        _stripDisallowedAttributes(node);
      }
      const childNodes = getChildNodes(node);
      if (childNodes) {
        for (let i = childNodes.length - 1; i >= 0; --i) {
          stack.push(childNodes[i]);
        }
      }
    }
  };
  const _neutralizePatchLinkage = function _neutralizePatchLinkage2(root) {
    if (!SAFE_FOR_XML) {
      return;
    }
    const stack = [root];
    while (stack.length > 0) {
      const node = stack.pop();
      const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
      if (nodeType === NODE_TYPE.processingInstruction || nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, node.data)) {
        try {
          remove(node);
        } catch (_) {
        }
        continue;
      }
      if (nodeType === NODE_TYPE.element) {
        const element = node;
        const lcTag = transformCaseFunc(getNodeName ? getNodeName(node) : node.nodeName);
        try {
          if (element.hasAttribute && element.hasAttribute("patchsrc")) {
            element.removeAttribute("patchsrc");
          }
          if (element.hasAttribute && element.hasAttribute("for") && lcTag !== "label" && lcTag !== "output") {
            element.removeAttribute("for");
          }
        } catch (_) {
        }
      }
      const childNodes = getChildNodes(node);
      if (childNodes) {
        for (let i = childNodes.length - 1; i >= 0; --i) {
          stack.push(childNodes[i]);
        }
      }
    }
  };
  const _initDocument = function _initDocument2(dirty) {
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = "<remove></remove>" + dirty;
    } else {
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) {
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
    }
    const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {
      }
    }
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, "template", null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document2.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  const _createNodeIterator = function _createNodeIterator2(root) {
    return createNodeIterator.call(
      root.ownerDocument || root,
      root,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION,
      null
    );
  };
  const _stripTemplateExpressions = function _stripTemplateExpressions2(value) {
    value = stringReplace(value, MUSTACHE_EXPR$1, " ");
    value = stringReplace(value, ERB_EXPR$1, " ");
    value = stringReplace(value, TMPLIT_EXPR$1, " ");
    return value;
  };
  const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
    var _node$querySelectorAl;
    node.normalize();
    const walker = createNodeIterator.call(
      node.ownerDocument || node,
      node,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let currentNode = walker.nextNode();
    while (currentNode) {
      currentNode.data = _stripTemplateExpressions(currentNode.data);
      currentNode = walker.nextNode();
    }
    const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, "template");
    if (templates) {
      arrayForEach(templates, (tmpl) => {
        if (_isDocumentFragment(tmpl.content)) {
          _scrubTemplateExpressions2(tmpl.content);
        }
      });
    }
  };
  const _isClobbered = function _isClobbered2(element) {
    const realTagName = getNodeName ? getNodeName(element) : null;
    if (typeof realTagName !== "string") {
      return false;
    }
    if (transformCaseFunc(realTagName) !== "form") {
      return false;
    }
    return typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    element.attributes !== getAttributes(element) || typeof element.removeAttribute !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    element.nodeType !== getNodeType(element) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    element.childNodes !== getChildNodes(element);
  };
  const _isDocumentFragment = function _isDocumentFragment2(value) {
    if (!getNodeType || typeof value !== "object" || value === null) {
      return false;
    }
    try {
      return getNodeType(value) === NODE_TYPE.documentFragment;
    } catch (_) {
      return false;
    }
  };
  const _isNode = function _isNode2(value) {
    if (!getNodeType || typeof value !== "object" || value === null) {
      return false;
    }
    try {
      return typeof getNodeType(value) === "number";
    } catch (_) {
      return false;
    }
  };
  function _executeHooks(hooks2, currentNode, data) {
    if (hooks2.length === 0) {
      return;
    }
    arrayForEach(hooks2, (hook) => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  const _isUnsafeNode = function _isUnsafeNode2(currentNode, tagName) {
    if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) {
      return true;
    }
    if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === "style" && _isNode(currentNode.firstElementChild)) {
      return true;
    }
    if (currentNode.nodeType === NODE_TYPE.processingInstruction) {
      return true;
    }
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, currentNode.data)) {
      return true;
    }
    return false;
  };
  const _sanitizeDisallowedNode = function _sanitizeDisallowedNode2(currentNode, tagName) {
    if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
      if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
        return false;
      }
      if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
        return false;
      }
    }
    if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
      const parentNode = getParentNode(currentNode);
      const childNodes = getChildNodes(currentNode);
      if (childNodes && parentNode) {
        const childCount = childNodes.length;
        for (let i = childCount - 1; i >= 0; --i) {
          const hoisted = IN_PLACE ? childNodes[i] : cloneNode(childNodes[i], true);
          parentNode.insertBefore(hoisted, getNextSibling(currentNode));
        }
      }
    }
    _forceRemove(currentNode);
    return true;
  };
  const _sanitizeElements = function _sanitizeElements2(currentNode, root) {
    _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
    if (currentNode !== root && getParentNode(currentNode) === null) {
      return true;
    }
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    const tagName = transformCaseFunc(getNodeName ? getNodeName(currentNode) : currentNode.nodeName);
    _executeHooks(hooks.uponSanitizeElement, currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    if (currentNode !== root && getParentNode(currentNode) === null) {
      return true;
    }
    if (_isUnsafeNode(currentNode, tagName)) {
      _forceRemove(currentNode);
      return true;
    }
    if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
      const removed = _sanitizeDisallowedNode(currentNode, tagName);
      if (removed === false) {
        _executeHooks(hooks.afterSanitizeElements, currentNode, null);
      }
      return removed;
    }
    const nt = getNodeType ? getNodeType(currentNode) : currentNode.nodeType;
    if (nt === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      const content = _stripTemplateExpressions(currentNode.textContent);
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
    return false;
  };
  const _isValidAttribute = function _isValidAttribute2(lcTag, lcName, value) {
    if (FORBID_ATTR[lcName]) {
      return false;
    }
    if (SAFE_FOR_XML && lcName === "patchsrc") {
      return false;
    }
    if (SAFE_FOR_XML && lcName === "for" && lcTag !== "label" && lcTag !== "output") {
      return false;
    }
    if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document2 || value in formElement)) {
      return false;
    }
    const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
    if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$1, lcName)) ;
    else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
    else if (!nameIsPermitted) {
      if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))
      ) ;
      else {
        return false;
      }
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
    else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
    else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
    else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
    else if (value) {
      return false;
    } else ;
    return true;
  };
  const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]);
  const _isBasicCustomElement = function _isBasicCustomElement2(tagName) {
    return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
  };
  const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute2(lcTag, lcName, namespaceURI, value) {
    if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function" && !namespaceURI) {
      switch (trustedTypes.getAttributeType(lcTag, lcName)) {
        case "TrustedHTML": {
          return _createTrustedHTML(value);
        }
        case "TrustedScriptURL": {
          return _createTrustedScriptURL(value);
        }
      }
    }
    return value;
  };
  const _setAttributeValue = function _setAttributeValue2(currentNode, name, namespaceURI, value) {
    try {
      if (namespaceURI) {
        currentNode.setAttributeNS(namespaceURI, name, value);
      } else {
        currentNode.setAttribute(name, value);
      }
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
      } else {
        arrayPop(DOMPurify.removed);
      }
    } catch (_) {
      _removeAttribute(name, currentNode);
    }
  };
  const _sanitizeAttributes = function _sanitizeAttributes2(currentNode) {
    _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
    const attributes = currentNode.attributes;
    if (!attributes || _isClobbered(currentNode)) {
      return;
    }
    const hookEvent = {
      attrName: "",
      attrValue: "",
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: void 0
    };
    let l = attributes.length;
    const lcTag = transformCaseFunc(currentNode.nodeName);
    while (l--) {
      const attr = attributes[l];
      const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
      const lcName = transformCaseFunc(name);
      const initValue = attrValue;
      let value = name === "value" ? initValue : stringTrim(initValue);
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = void 0;
      _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
      value = hookEvent.attrValue;
      if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name") && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
        _removeAttribute(name, currentNode);
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      if (lcName === "attributename" && stringMatch(value, "href")) {
        _removeAttribute(name, currentNode);
        continue;
      }
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      if (!hookEvent.keepAttr) {
        _removeAttribute(name, currentNode);
        continue;
      }
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      if (SAFE_FOR_TEMPLATES) {
        value = _stripTemplateExpressions(value);
      }
      if (!_isValidAttribute(lcTag, lcName, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
      if (value !== initValue) {
        _setAttributeValue(currentNode, name, namespaceURI, value);
      }
    }
    _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
  };
  const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
      _sanitizeElements(shadowNode, fragment);
      _sanitizeAttributes(shadowNode);
      if (_isDocumentFragment(shadowNode.content)) {
        _sanitizeShadowDOM2(shadowNode.content);
      }
      const shadowNodeType = getNodeType ? getNodeType(shadowNode) : shadowNode.nodeType;
      if (shadowNodeType === NODE_TYPE.element) {
        const innerSr = getShadowRoot(shadowNode);
        if (_isDocumentFragment(innerSr)) {
          _sanitizeAttachedShadowRoots(innerSr);
          _sanitizeShadowDOM2(innerSr);
        }
      }
    }
    _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
  };
  const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots2(root) {
    const stack = [{
      node: root,
      shadow: null
    }];
    while (stack.length > 0) {
      const item = stack.pop();
      if (item.shadow) {
        _sanitizeShadowDOM2(item.shadow);
        continue;
      }
      const node = item.node;
      const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
      const isElement = nodeType === NODE_TYPE.element;
      const childNodes = getChildNodes(node);
      if (childNodes) {
        for (let i = childNodes.length - 1; i >= 0; --i) {
          stack.push({
            node: childNodes[i],
            shadow: null
          });
        }
      }
      if (isElement) {
        const rootName = getNodeName ? getNodeName(node) : null;
        if (typeof rootName === "string" && transformCaseFunc(rootName) === "template") {
          const content = node.content;
          if (_isDocumentFragment(content)) {
            stack.push({
              node: content,
              shadow: null
            });
          }
        }
      }
      if (isElement) {
        const sr = getShadowRoot(node);
        if (_isDocumentFragment(sr)) {
          stack.push({
            node: null,
            shadow: sr
          }, {
            node: sr,
            shadow: null
          });
        }
      }
    }
  };
  DOMPurify.sanitize = function(dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = "<!-->";
    }
    if (typeof dirty !== "string" && !_isNode(dirty)) {
      dirty = stringifyValue(dirty);
      if (typeof dirty !== "string") {
        throw typeErrorCreate("dirty is not a string, aborting");
      }
    }
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    if (SET_CONFIG) {
      ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
      ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
    } else {
      _parseConfig(cfg);
    }
    if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) {
      ALLOWED_TAGS = clone(ALLOWED_TAGS);
    }
    if (hooks.uponSanitizeAttribute.length > 0) {
      ALLOWED_ATTR = clone(ALLOWED_ATTR);
    }
    DOMPurify.removed = [];
    const inPlace = IN_PLACE && typeof dirty !== "string" && _isNode(dirty);
    if (inPlace) {
      _neutralizePatchLinkage(dirty);
      const nn = getNodeName ? getNodeName(dirty) : dirty.nodeName;
      if (typeof nn === "string") {
        const tagName = transformCaseFunc(nn);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          _neutralizeRoot(dirty);
          throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
        }
      }
      if (_isClobbered(dirty)) {
        _neutralizeRoot(dirty);
        throw typeErrorCreate("root node is clobbered and cannot be sanitized in-place");
      }
      try {
        _sanitizeAttachedShadowRoots(dirty);
      } catch (error) {
        _neutralizeRoot(dirty);
        throw error;
      }
    } else if (_isNode(dirty)) {
      body = _initDocument("<!---->");
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") {
        body = importedNode;
      } else if (importedNode.nodeName === "HTML") {
        body = importedNode;
      } else {
        body.appendChild(importedNode);
      }
      _sanitizeAttachedShadowRoots(importedNode);
    } else {
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf("<") === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
      }
      body = _initDocument(dirty);
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
      }
    }
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    const walkRoot = inPlace ? dirty : body;
    const nodeIterator = _createNodeIterator(walkRoot);
    try {
      while (currentNode = nodeIterator.nextNode()) {
        _sanitizeElements(currentNode, walkRoot);
        _sanitizeAttributes(currentNode);
        if (_isDocumentFragment(currentNode.content)) {
          _sanitizeShadowDOM2(currentNode.content);
        }
      }
    } catch (error) {
      if (inPlace) {
        _neutralizeRoot(dirty);
        arrayForEach(DOMPurify.removed, (entry) => {
          if (entry.element) {
            _neutralizeSubtree(entry.element);
          }
        });
      }
      throw error;
    }
    if (inPlace) {
      arrayForEach(DOMPurify.removed, (entry) => {
        if (entry.element) {
          _neutralizeSubtree(entry.element);
        }
      });
      if (SAFE_FOR_TEMPLATES) {
        _scrubTemplateExpressions2(dirty);
      }
      return dirty;
    }
    if (RETURN_DOM) {
      if (SAFE_FOR_TEMPLATES) {
        _scrubTemplateExpressions2(body);
      }
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
    }
    if (SAFE_FOR_TEMPLATES) {
      serializedHTML = _stripTemplateExpressions(serializedHTML);
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function() {
    let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
    SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
    SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
  };
  DOMPurify.clearConfig = function() {
    CONFIG = null;
    SET_CONFIG = false;
    SET_CONFIG_ALLOWED_TAGS = null;
    SET_CONFIG_ALLOWED_ATTR = null;
    trustedTypesPolicy = defaultTrustedTypesPolicy;
    emptyHTML = "";
  };
  DOMPurify.isValidAttribute = function(tag, attr, value) {
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };
  DOMPurify.addHook = function(entryPoint, hookFunction) {
    if (typeof hookFunction !== "function") {
      return;
    }
    if (!objectHasOwnProperty(hooks, entryPoint)) {
      return;
    }
    arrayPush(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function(entryPoint, hookFunction) {
    if (!objectHasOwnProperty(hooks, entryPoint)) {
      return void 0;
    }
    if (hookFunction !== void 0) {
      const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
      return index === -1 ? void 0 : arraySplice(hooks[entryPoint], index, 1)[0];
    }
    return arrayPop(hooks[entryPoint]);
  };
  DOMPurify.removeHooks = function(entryPoint) {
    if (!objectHasOwnProperty(hooks, entryPoint)) {
      return;
    }
    hooks[entryPoint] = [];
  };
  DOMPurify.removeAllHooks = function() {
    hooks = _createHooksMap();
  };
  return DOMPurify;
}
var purify = createDOMPurify();

// src/CboCardUniteUs/CboCardUniteUs.tsx
import { jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var BULK_REFERRAL_FEATURE_ENABLED = false;
var MAX_VISIBLE_SERVICES = 5;
var DESCRIPTION_WORD_LIMIT = 26;
var CLOSED_TEXT = "Closed";
var NO_ADDRESS_PLACEHOLDER = "--";
var ABBREVIATION_PHRASES = ["lgbtq", "hiv", "aids"];
var ABBREVIATION_SUBSTITUTIONS = {
  plus: "+"
};
var PROPER_NOUNS = ["americans", "alaska"];
var DAYS_OF_WEEK = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday"
];
var InvisibleDivider = styled2("hr", { border: "none" });
var stripHtmlTags = (html2) => {
  const el = document.createElement("div");
  el.innerHTML = purify.sanitize(html2);
  return el.textContent || el.innerText || "";
};
var capitalizeFirstLetter = (word) => {
  var _a;
  return ((_a = word == null ? void 0 : word.charAt(0)) == null ? void 0 : _a.toUpperCase()) + (word == null ? void 0 : word.slice(1));
};
var formatPopulationKey = (key) => {
  return key.split("_").map((word, idx) => {
    if (ABBREVIATION_PHRASES.includes(word)) {
      return word.toUpperCase();
    }
    if (ABBREVIATION_SUBSTITUTIONS[word]) {
      return ABBREVIATION_SUBSTITUTIONS[word];
    }
    return idx === 0 || PROPER_NOUNS.includes(word) ? word.charAt(0).toUpperCase() + word.slice(1) : word;
  }).join(" ");
};
var getFullAddress = (location) => {
  if (!location) {
    return NO_ADDRESS_PLACEHOLDER;
  }
  const { line_1, line_2, city, state, postal_code, country } = location;
  const addressParts = [line_1, line_2].filter(Boolean);
  const cityStateZip = [city, state, postal_code].filter(Boolean).join(" ");
  const fullAddress = [...addressParts, cityStateZip, country].filter(Boolean).join(", ");
  return fullAddress || NO_ADDRESS_PLACEHOLDER;
};
var getOpenCloseTimesByDay = (office, day) => {
  var _a;
  const openHours = office == null ? void 0 : office.hours;
  if (!openHours) {
    return CLOSED_TEXT;
  }
  const dayHours = openHours[day.toLowerCase()];
  return (_a = dayHours == null ? void 0 : dayHours.map(({ opens, closes }) => {
    return `${opens}-${closes}`;
  })) != null ? _a : CLOSED_TEXT;
};
var getClosestLocation = (programData) => {
  var _a, _b;
  return ((_a = programData == null ? void 0 : programData.document) == null ? void 0 : _a.locations.find((location) => {
    return location.is_closest;
  })) || ((_b = programData == null ? void 0 : programData.document) == null ? void 0 : _b.locations[0]);
};
var TRUNCATED_TEXT_STYLE = {
  maxWidth: "100%",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 2,
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var EXPANDED_TEXT_STYLE = {
  maxWidth: "100%",
  display: "block",
  overflow: "visible"
};
var CARD_BORDER_STYLE = {
  border: "solid #D3D3D3 1px",
  borderRadius: "10px",
  overflow: "hidden"
};
var CONTAINER_STYLE = {
  paddingTop: "1rem",
  paddingBottom: "1rem",
  width: "100%"
};
var LEFT_SECTION_STYLE = {
  padding: "15px",
  width: "67%"
};
var RIGHT_SECTION_STYLE = {
  backgroundColor: "#EEF8FB",
  padding: "24px 24px 15px 24px",
  width: "33%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between"
};
var PseudoLinkButton = ({
  onClick,
  height,
  style,
  children
}) => {
  return /* @__PURE__ */ jsx13(
    Button,
    {
      variant: "text",
      style: __spreadValues({
        padding: 0,
        height: height || "auto"
      }, style),
      onClick,
      children
    }
  );
};
var CboCardUniteUs = ({
  programData,
  setReferTo,
  setExpandedViewProgram,
  checked,
  setPChecked,
  onClickService,
  onClickServingAttribute,
  onClickPrint,
  onClickEmail,
  onClickTitle
}) => {
  var _a, _b, _c, _d, _e, _f;
  const [showMore, toggleShowMore] = useState9(false);
  const [showOpenHours, toggleShowOpenHours] = useState9(false);
  const [descriptionExpanded, setDescriptionExpanded] = useState9(false);
  const [servicesExpanded, setServicesExpanded] = useState9(false);
  const [isChecked, setChecked] = useState9(checked);
  const services = useMemo(
    () => {
      var _a2;
      return (_a2 = programData.relationships.services.data) != null ? _a2 : [];
    },
    [programData.relationships.services.data]
  );
  const visibleServices = useMemo(
    () => servicesExpanded ? services : services.slice(0, MAX_VISIBLE_SERVICES),
    [services, servicesExpanded]
  );
  const displayNames = useMemo(
    () => new Intl.DisplayNames(["en"], { type: "language" }),
    []
  );
  const closestLocation = useMemo(
    () => getClosestLocation(programData),
    [programData]
  );
  const contactInfo = useMemo(
    () => {
      var _a2, _b2, _c2;
      return {
        email: (_b2 = (_a2 = closestLocation == null ? void 0 : closestLocation.email_addresses) == null ? void 0 : _a2[0]) != null ? _b2 : "",
        websiteUrl: ((_c2 = programData == null ? void 0 : programData.document) == null ? void 0 : _c2.website_url) || "",
        addressText: getFullAddress(closestLocation)
      };
    },
    [closestLocation, (_a = programData == null ? void 0 : programData.document) == null ? void 0 : _a.website_url]
  );
  const strippedDescription = useMemo(
    () => stripHtmlTags(programData.document.description),
    [programData.document.description]
  );
  const descriptionWordCount = useMemo(
    () => strippedDescription.trim().split(/\s+/).length,
    [strippedDescription]
  );
  const hasMultipleServices = useMemo(
    () => services.length > MAX_VISIBLE_SERVICES,
    [services.length]
  );
  const handleCheckboxChange = useCallback2((e) => {
    var _a2;
    e.stopPropagation();
    setChecked((_a2 = e == null ? void 0 : e.target) == null ? void 0 : _a2.checked);
  }, []);
  const handleTitleClick = useCallback2(() => {
    setExpandedViewProgram(programData.id);
  }, [programData.id, setExpandedViewProgram]);
  const toggleDescription = useCallback2(() => {
    setDescriptionExpanded((prev) => !prev);
  }, []);
  const toggleServices = useCallback2(() => {
    setServicesExpanded((prev) => !prev);
  }, []);
  const toggleHours = useCallback2(() => {
    toggleShowOpenHours((prev) => !prev);
  }, []);
  const toggleDetails = useCallback2(() => {
    toggleShowMore((prev) => !prev);
  }, []);
  const handleReferClick = useCallback2(() => {
    setReferTo(programData);
  }, [programData, setReferTo]);
  useEffect3(() => {
    setPChecked(isChecked, programData);
  }, [isChecked, programData, setPChecked]);
  return /* @__PURE__ */ jsx13("div", { style: CONTAINER_STYLE, children: /* @__PURE__ */ jsxs9(
    Flex,
    {
      justify: "space-between",
      style: CARD_BORDER_STYLE,
      id: `${programData.id}-card`,
      children: [
        /* @__PURE__ */ jsxs9("div", { style: LEFT_SECTION_STYLE, children: [
          /* @__PURE__ */ jsx13(Flex, { direction: "row", children: /* @__PURE__ */ jsx13("div", { style: { cursor: "pointer" }, tabIndex: 0, role: "button", children: /* @__PURE__ */ jsx13(
            Button,
            {
              onClick: onClickTitle,
              variant: "text",
              style: {
                height: "auto",
                textAlign: "left",
                padding: 0,
                marginLeft: -12,
                wordWrap: "break-word"
              },
              "data-cy": `cbo-card-title-button-${programData.id}`,
              children: /* @__PURE__ */ jsxs9(Layout3.Group, { children: [
                BULK_REFERRAL_FEATURE_ENABLED && /* @__PURE__ */ jsx13(
                  Checkbox3,
                  {
                    label: "",
                    isChecked,
                    onChange: handleCheckboxChange
                  }
                ),
                /* @__PURE__ */ jsxs9(
                  "span",
                  {
                    onClick: handleTitleClick,
                    style: { cursor: "pointer" },
                    children: [
                      BULK_REFERRAL_FEATURE_ENABLED && /* @__PURE__ */ jsx13(
                        Heading2,
                        {
                          size: "sm",
                          color: "$core.color.brand.60",
                          style: { marginLeft: "-20px", marginBottom: 0 },
                          children: (_b = programData == null ? void 0 : programData.document) == null ? void 0 : _b.name
                        }
                      ),
                      !BULK_REFERRAL_FEATURE_ENABLED && /* @__PURE__ */ jsx13(
                        Heading2,
                        {
                          size: "sm",
                          color: "$core.color.brand.60",
                          style: { marginLeft: "12px", marginBottom: 0 },
                          children: (_c = programData == null ? void 0 : programData.document) == null ? void 0 : _c.name
                        }
                      )
                    ]
                  }
                )
              ] })
            }
          ) }) }),
          ((_e = (_d = programData.relationships.provider) == null ? void 0 : _d.data.document) == null ? void 0 : _e.name) && /* @__PURE__ */ jsxs9(Text4, { children: [
            "by \xA0",
            /* @__PURE__ */ jsx13(Text4, { color: "$core.color.brand.60", fontWeight: "regular", fontSize: "md", style: { display: "inline" }, children: programData.relationships.provider.data.document.name })
          ] }),
          /* @__PURE__ */ jsx13(InvisibleDivider, {}),
          descriptionExpanded ? /* @__PURE__ */ jsx13(
            "div",
            {
              style: EXPANDED_TEXT_STYLE,
              dangerouslySetInnerHTML: {
                __html: purify.sanitize(programData.document.description)
              }
            }
          ) : /* @__PURE__ */ jsx13("div", { style: TRUNCATED_TEXT_STYLE, children: /* @__PURE__ */ jsx13(Text4, { fontWeight: "regular", fontSize: "md", children: strippedDescription }) }),
          /* @__PURE__ */ jsx13(InvisibleDivider, {}),
          /* @__PURE__ */ jsx13("div", { children: descriptionWordCount > DESCRIPTION_WORD_LIMIT && /* @__PURE__ */ jsx13(PseudoLinkButton, { onClick: toggleDescription, height: 20, children: descriptionExpanded ? "Show less" : "Show more" }) }),
          /* @__PURE__ */ jsx13(
            InvisibleDivider,
            {
              style: {
                padding: 4
              }
            }
          ),
          /* @__PURE__ */ jsxs9("span", { style: { fontWeight: "bold" }, children: [
            "Main services:\xA0",
            visibleServices.map((service, idx) => /* @__PURE__ */ jsxs9(React10.Fragment, { children: [
              /* @__PURE__ */ jsx13(
                PseudoLinkButton,
                {
                  onClick: () => onClickService(service.label),
                  height: 20,
                  style: { minHeight: 0, lineHeight: 1.15, verticalAlign: "baseline" },
                  children: capitalizeFirstLetter(service.label)
                }
              ),
              idx !== visibleServices.length - 1 ? ", " : ""
            ] }, service.id || idx))
          ] }),
          hasMultipleServices && /* @__PURE__ */ jsx13("div", { children: /* @__PURE__ */ jsx13(PseudoLinkButton, { onClick: toggleServices, height: 20, children: servicesExpanded ? "Show less" : "Show more" }) }),
          /* @__PURE__ */ jsx13(
            InvisibleDivider,
            {
              style: {
                padding: 8
              }
            }
          ),
          /* @__PURE__ */ jsx13("div", { children: /* @__PURE__ */ jsxs9("span", { style: { fontWeight: "bold" }, children: [
            "Serving populations:\xA0",
            programData.document.population_specializations && programData.document.population_specializations.length > 0 ? programData.document.population_specializations.map(
              (tag, idx) => {
                var _a2, _b2;
                return /* @__PURE__ */ jsxs9(React10.Fragment, { children: [
                  /* @__PURE__ */ jsx13(
                    PseudoLinkButton,
                    {
                      onClick: () => onClickServingAttribute(tag),
                      height: 20,
                      style: { minHeight: 0, lineHeight: 1.15, verticalAlign: "baseline" },
                      children: formatPopulationKey(tag)
                    }
                  ),
                  idx !== ((_b2 = (_a2 = programData.document.population_specializations) == null ? void 0 : _a2.length) != null ? _b2 : 0) - 1 ? ", " : ""
                ] }, tag);
              }
            ) : /* @__PURE__ */ jsx13("span", { style: { fontWeight: "normal" }, children: "No serving information available" })
          ] }) }),
          showMore && /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsxs9("div", { style: { paddingTop: "10px" }, children: [
              /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "bold", fontSize: "md", children: "Cost: \xA0" }),
              programData.document.payment_options && programData.document.payment_options.length > 0 ? /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: programData.document.payment_options.map((payment_option) => {
                return capitalizeFirstLetter(
                  payment_option.replace(/_/g, " ")
                );
              }).join(", ") }) : /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: "No pricing information is available" })
            ] }),
            /* @__PURE__ */ jsxs9("div", { style: { paddingTop: "10px" }, children: [
              /* @__PURE__ */ jsx13(
                Text4,
                {
                  "data-cy": "program-card-language-details",
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "md",
                  children: "Language: \xA0"
                }
              ),
              /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: programData.document.languages.map((language) => {
                return displayNames.of(language);
              }).join(", ") })
            ] }),
            /* @__PURE__ */ jsxs9("div", { style: { paddingTop: "10px" }, children: [
              /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "bold", fontSize: "md", children: "Population Restrictions: \xA0" }),
              programData.document.population_restrictions && programData.document.population_restrictions.length > 0 ? /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: programData.document.population_restrictions.map((restriction) => {
                return capitalizeFirstLetter(
                  restriction.replace(/_/g, " ")
                );
              }).join(", ") }) : /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: "No population restrictions" })
            ] }),
            /* @__PURE__ */ jsxs9("div", { style: { paddingTop: "10px" }, children: [
              /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "bold", fontSize: "md", children: "Restricted Cities: \xA0" }),
              programData.document.restricted_cities && programData.document.restricted_cities.length > 0 ? /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: programData.document.restricted_cities.map((city) => {
                return capitalizeFirstLetter(city.replace(/_/g, " "));
              }).join(", ") }) : /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: "No restricted cities" })
            ] }),
            /* @__PURE__ */ jsxs9("div", { style: { paddingTop: "10px" }, children: [
              /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "bold", fontSize: "md", children: "Restricted Counties: \xA0" }),
              programData.document.restricted_counties && programData.document.restricted_counties.length > 0 ? /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: programData.document.restricted_counties.map((county) => {
                return capitalizeFirstLetter(county.replace(/_/g, " "));
              }).join(", ") }) : /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: "No restricted counties" })
            ] }),
            /* @__PURE__ */ jsxs9("div", { style: { paddingTop: "10px" }, children: [
              /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "bold", fontSize: "md", children: "Restricted States: \xA0" }),
              programData.document.restricted_states && programData.document.restricted_states.length > 0 ? /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: programData.document.restricted_states.map((state) => {
                return capitalizeFirstLetter(state.replace(/_/g, " "));
              }).join(", ") }) : /* @__PURE__ */ jsx13(Text4, { color: "black", fontWeight: "regular", fontSize: "md", children: "No restricted states" })
            ] })
          ] }),
          /* @__PURE__ */ jsx13("div", { children: (closestLocation == null ? void 0 : closestLocation.hours) && /* @__PURE__ */ jsxs9(React10.Fragment, { children: [
            /* @__PURE__ */ jsxs9(
              "button",
              {
                "data-cy": "program-card-btn-toggle-hours",
                type: "button",
                style: {
                  paddingTop: "10px",
                  display: "inline-flex",
                  flexDirection: "row",
                  width: "100%",
                  cursor: "pointer",
                  textAlign: "left",
                  paddingBottom: "5px"
                },
                onClick: toggleHours,
                children: [
                  /* @__PURE__ */ jsx13(Text4, { color: "$interactive1", fontWeight: "bold", fontSize: "md", children: "See Open Hours" }),
                  !showOpenHours ? /* @__PURE__ */ jsx13(
                    IconSymbol,
                    {
                      icon: "keyboard_arrow_down",
                      size: "22px",
                      color: "$interactive1",
                      id: "expandMore"
                    }
                  ) : /* @__PURE__ */ jsx13(
                    IconSymbol,
                    {
                      icon: "keyboard_arrow_up",
                      size: "22px",
                      color: "$interactive1",
                      id: "expandLess"
                    }
                  )
                ]
              }
            ),
            showOpenHours && /* @__PURE__ */ jsx13(
              "div",
              {
                "data-cy": "program-card-hours",
                style: {
                  float: "left",
                  paddingTop: "5px",
                  paddingBottom: "5px",
                  width: "100%"
                },
                children: DAYS_OF_WEEK.map((day) => {
                  const hours = getOpenCloseTimesByDay(closestLocation, day);
                  const hoursText = Array.isArray(hours) ? hours.map((h) => h.replace(/\b0(\d:)/g, "$1")).join(", ") : hours.replace(/\b0(\d:)/g, "$1");
                  return /* @__PURE__ */ jsxs9("div", { style: { display: "flex", gap: "8px", lineHeight: 1.5 }, children: [
                    /* @__PURE__ */ jsxs9("span", { style: { fontWeight: "bold", minWidth: "100px" }, children: [
                      capitalizeFirstLetter(day),
                      ":"
                    ] }),
                    /* @__PURE__ */ jsx13("span", { children: hoursText })
                  ] }, day);
                })
              }
            )
          ] }) }),
          /* @__PURE__ */ jsx13(
            Flex,
            {
              alignItems: "center",
              style: {
                paddingTop: 8,
                width: "100%"
              },
              children: /* @__PURE__ */ jsx13("div", { style: { paddingTop: "15px", marginTop: "-20px" }, children: /* @__PURE__ */ jsx13("div", { children: programData.document.receiving_referrals ? /* @__PURE__ */ jsxs9(Flex, { alignItems: "center", style: { gap: "6px" }, children: [
                /* @__PURE__ */ jsx13(IconSymbol, { icon: "verified", size: "24px", color: "#007000" }),
                /* @__PURE__ */ jsx13(Text4, { color: "#007000", fontWeight: "bold", fontSize: "md", children: "This organization receives member information" })
              ] }) : /* @__PURE__ */ jsxs9(Flex, { alignItems: "center", style: { gap: "6px" }, children: [
                /* @__PURE__ */ jsx13(
                  IconSymbol,
                  {
                    icon: "do_not_disturb_on",
                    size: "24px",
                    color: "#E4780C"
                  }
                ),
                /* @__PURE__ */ jsx13(Text4, { color: "#E4780C", fontWeight: "bold", fontSize: "md", children: "This organization does not receive member information" }),
                /* @__PURE__ */ jsx13(
                  Popover,
                  {
                    content: "\n                      Log referrals to contribute to our referral program\n                      and enable essential follow-up actions to support\n                      the member. When logging a referral, member\n                      information is not sent to the organization.\n                      Instead, share the organization's details with the\n                      member.\n                    "
                  }
                )
              ] }) }) })
            }
          ),
          /* @__PURE__ */ jsxs9(Layout3.Group, { alignLayout: "between", children: [
            /* @__PURE__ */ jsxs9(
              Flex,
              {
                alignItems: "center",
                style: {
                  paddingTop: 8
                },
                children: [
                  /* @__PURE__ */ jsx13(
                    Button,
                    {
                      "data-cy": "cbo-card-print-button",
                      onClick: onClickPrint,
                      variant: "text",
                      style: {
                        paddingLeft: 0,
                        paddingRight: 8
                      },
                      children: /* @__PURE__ */ jsx13(
                        IconSymbol,
                        {
                          icon: "print",
                          variant: "outlined",
                          style: {
                            cursor: "pointer",
                            paddingLeft: 0,
                            marginTop: 4
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ jsx13(
                    Button,
                    {
                      "data-cy": "cbo-card-email-button",
                      onClick: onClickEmail,
                      variant: "text",
                      style: {
                        paddingLeft: 8,
                        paddingRight: 8
                      },
                      children: /* @__PURE__ */ jsx13(IconSymbol, { icon: "mail", variant: "outlined" })
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ jsxs9(
              "button",
              {
                "data-cy": "program-card-btn-toggle-additional-details",
                type: "button",
                style: {
                  display: "inline-flex",
                  flexDirection: "row",
                  paddingRight: "2rem",
                  cursor: "pointer",
                  textAlign: "left",
                  paddingLeft: "0px"
                },
                onClick: toggleDetails,
                children: [
                  !showMore && /* @__PURE__ */ jsx13(Text4, { color: "$core.color.brand.60", fontWeight: "bold", fontSize: "md", children: "Show more" }),
                  showMore && /* @__PURE__ */ jsx13(Text4, { color: "$core.color.brand.60", fontWeight: "bold", fontSize: "md", children: "Show less" })
                ]
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs9("div", { style: RIGHT_SECTION_STYLE, children: [
          /* @__PURE__ */ jsx13(
            CboCardUniteUsNextSteps,
            {
              closestOfficeAddressText: contactInfo.addressText,
              closestOfficeEmail: contactInfo.email,
              closestOfficePhone: (_f = closestLocation == null ? void 0 : closestLocation.phone_numbers) != null ? _f : [""],
              closestOfficeWebsite: contactInfo.websiteUrl
            }
          ),
          /* @__PURE__ */ jsx13(Button, { style: { width: "100%" }, onClick: handleReferClick, children: programData.document.receiving_referrals ? "Refer" : "Log Referral" })
        ] })
      ]
    }
  ) });
};

// src/CboCardFindHelp/CboCardFindhelpNextSteps.tsx
import { Text as Text5 } from "@uhg-abyss/web/ui/Text";
import { jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var CboCardFindhelpNextSteps = ({
  nextStepsData,
  firstOfficeAddressText,
  firstOfficeEmail,
  firstOfficeWebsite,
  firstOfficePhone,
  source
}) => {
  return /* @__PURE__ */ jsxs10(
    "div",
    {
      style: {
        overflow: "hidden"
      },
      children: [
        source == "advocate" ? /* @__PURE__ */ jsx14(Text5, { color: "black", fontWeight: "bold", fontSize: "md", children: "Next steps:" }) : "",
        nextStepsData && nextStepsData.length > 0 ? /* @__PURE__ */ jsx14("ul", { children: nextStepsData == null ? void 0 : nextStepsData.map((nextStep, idx) => {
          const markup = nextStepsMarkupFromData(
            nextStep,
            firstOfficeAddressText,
            firstOfficeEmail,
            firstOfficeWebsite,
            firstOfficePhone
          );
          if (markup === null) return null;
          return /* @__PURE__ */ jsx14("li", { children: markup }, idx);
        }) }) : /* @__PURE__ */ jsx14("div", { children: /* @__PURE__ */ jsx14(Text5, { children: "No next steps available." }) })
      ]
    }
  );
};
function nextStepsMarkupFromData(data, firstOfficeAddrText, firstOfficeEmail, firstOfficePhone, firstOfficeWebsite) {
  switch (data.channel) {
    case "phone":
      return /* @__PURE__ */ jsxs10(Text5, { children: [
        "Call ",
        /* @__PURE__ */ jsx14("a", { href: `tel:${data.contact}`, children: data.contact }),
        " to",
        " ",
        data.action,
        "."
      ] });
    case "location":
      return /* @__PURE__ */ jsxs10("span", { children: [
        "Go to ",
        firstOfficeAddrText,
        " to ",
        data.action,
        "."
      ] });
    case "phone_office":
      return /* @__PURE__ */ jsxs10("span", { "data-cy": "phone_office", children: [
        "Call ",
        /* @__PURE__ */ jsx14("a", { children: firstOfficePhone }),
        " (your nearest location) to",
        " ",
        data.action,
        "."
      ] });
    case "external_apply":
      return /* @__PURE__ */ jsxs10("span", { children: [
        "Apply on their ",
        /* @__PURE__ */ jsx14("a", { href: data.contact, children: data.contact }),
        " to",
        " ",
        data.action,
        "."
      ] });
    case "website":
      return /* @__PURE__ */ jsxs10("span", { children: [
        "Go to the website ",
        /* @__PURE__ */ jsx14("a", { href: data.contact, children: data.contact }),
        " to",
        " ",
        data.action,
        "."
      ] });
    case "email":
      return /* @__PURE__ */ jsxs10("span", { children: [
        "Write an email to",
        " ",
        /* @__PURE__ */ jsx14("a", { href: `mailto:${data.contact}`, children: data.contact }),
        " to ",
        data.action,
        "."
      ] });
    case "external_contact":
      return /* @__PURE__ */ jsxs10("span", { "data-cy": "external_contact", children: [
        "Contact on their ",
        /* @__PURE__ */ jsx14("a", { href: data.contact, children: data.contact }),
        " to",
        " ",
        data.action,
        "."
      ] });
    case "external_schedule":
      return /* @__PURE__ */ jsxs10("span", { "data-cy": "external_schedule", children: [
        "Schedule on their ",
        /* @__PURE__ */ jsx14("a", { children: data.contact }),
        " to ",
        data.action,
        "."
      ] });
    case "referral_ext":
      return /* @__PURE__ */ jsxs10("span", { "data-cy": "referral_ext", children: [
        "Get a referral from ",
        /* @__PURE__ */ jsx14(Text5, { color: "$primary1", children: data.contact }),
        " to",
        " ",
        data.action,
        "."
      ] });
    case "website_office":
      return /* @__PURE__ */ jsxs10("span", { "data-cy": "website_office", children: [
        "Go to the website",
        " ",
        /* @__PURE__ */ jsx14("a", { href: firstOfficeWebsite, children: firstOfficeWebsite }),
        " to ",
        data.action,
        "."
      ] });
    case "email_office":
      return /* @__PURE__ */ jsxs10("span", { children: [
        "Write an email to",
        " ",
        /* @__PURE__ */ jsx14("a", { href: `mailto:${firstOfficeEmail}`, children: firstOfficeEmail }),
        " (your nearest location) to ",
        data.action,
        "."
      ] });
    // Why is the copy like this? This doesn't really make sense as a sentence. Preserving for the sake of parity with Angular app.
    case "referral_ab":
      return /* @__PURE__ */ jsxs10("span", { children: [
        "Get a referral from",
        " ",
        /* @__PURE__ */ jsxs10(Text5, { children: [
          "Program ID: ",
          data.contact.split("|")[0],
          ", Program Name:",
          " ",
          data.contact.split("|")[1]
        ] }),
        " ",
        "to ",
        data.action,
        "."
      ] });
    default: {
      console.warn(
        "Encountered program next steps which did not conform to expectations. Next steps were ",
        data
      );
      return null;
    }
  }
}

// src/BulkReferDropdownButton/index.tsx
import React11, { useEffect as useEffect4, useState as useState10 } from "react";
import { DropdownMenu } from "@uhg-abyss/web/ui/DropdownMenu";
import { IconSymbol as IconSymbol2 } from "@uhg-abyss/web/ui/IconSymbol";
import { Layout as Layout4 } from "@uhg-abyss/web/ui/Layout";
import { jsx as jsx15 } from "react/jsx-runtime";
var BulkReferDropdownButton = ({
  bulkReferringLength,
  onClickSave,
  onClickCancel
}) => {
  const [menuItems, setMenuItems] = useState10([]);
  useEffect4(() => {
    if (bulkReferringLength > 0) {
      setMenuItems([
        {
          title: "Refer",
          onClick: () => {
            onClickSave();
          },
          icon: /* @__PURE__ */ jsx15(IconSymbol2, { icon: "save" })
        },
        {
          title: "Cancel bulk refer",
          icon: /* @__PURE__ */ jsx15(IconSymbol2, { icon: "cancel" }),
          onClick: () => {
            onClickCancel();
          }
        }
      ]);
    } else {
      setMenuItems([]);
    }
  }, [bulkReferringLength]);
  return /* @__PURE__ */ jsx15("div", { children: /* @__PURE__ */ jsx15(React11.Fragment, { children: /* @__PURE__ */ jsx15(Layout4.Group, { children: /* @__PURE__ */ jsx15(
    DropdownMenu,
    {
      outline: true,
      label: `Bulk refer (${bulkReferringLength})`,
      before: /* @__PURE__ */ jsx15(IconSymbol2, { icon: "view_cozy" }),
      menuItems,
      isDisabled: bulkReferringLength === 0,
      css: { "abyss-button-root": { borderRadius: 0 }, "abyss-dropdown-menu-trigger-root": { borderRadius: 0 } }
    }
  ) }) }) });
};

// src/CboSubcategoryModal/index.tsx
import { Grid as Grid2 } from "@uhg-abyss/web/ui/Grid";
import { ModalDialog as ModalDialog2 } from "@uhg-abyss/web/ui/ModalDialog";
import { TextInput as TextInput5 } from "@uhg-abyss/web/ui/TextInput";
import React12, { useMemo as useMemo2, useState as useState11, useEffect as useEffect5, useRef } from "react";
import { styled as styled3 } from "@uhg-abyss/web/tools/styled";
import { jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
var HoverText = styled3("button", {
  color: "#196ecf",
  fontWeight: "bold",
  fontSize: "$sm",
  fontFamily: "inherit",
  background: "none",
  border: "none",
  padding: "0",
  cursor: "pointer",
  textAlign: "left",
  width: "100%",
  "&:focus-visible": {
    outline: "2px solid #196ecf",
    outlineOffset: "2px",
    borderRadius: "2px"
  },
  "&.commoncategoryHover:hover": {
    textDecoration: "underline 2px",
    textDecorationThickness: "3px",
    textUnderlineOffset: "0.4em",
    cursor: "pointer"
  }
});
function flattenRecursiveCategoryChildren(category) {
  var _a;
  if (!category.children) return [];
  return (_a = category.children) == null ? void 0 : _a.flatMap((subcategory) => {
    return [subcategory, ...flattenRecursiveCategoryChildren(subcategory)];
  });
}
function prettyTextToKebabCase(text2) {
  return text2.toLowerCase().replace(/[\s/]/g, "-").replace(/&/g, "and");
}
var CommonModal = ({
  categoryData,
  currentTopLevelCategory,
  isOpen,
  setIsOpen,
  onClickCategoryFilter
}) => {
  var _a, _b, _c;
  const currentCategoryData = useMemo2(() => {
    return currentTopLevelCategory !== null ? categoryData.find((category) => {
      return category.label === currentTopLevelCategory;
    }) : void 0;
  }, [currentTopLevelCategory, categoryData]);
  const flattenedCategoryData = useMemo2(() => {
    return currentCategoryData ? flattenRecursiveCategoryChildren(currentCategoryData).sort((a, b) => {
      return a.label.localeCompare(b.label);
    }) : [];
  }, [currentCategoryData]);
  const [filterByQueryValue, setFilterByQueryValue] = useState11("");
  const [statusMessage, setStatusMessage] = useState11("");
  const debounceRef = useRef(null);
  const filteredCategories = flattenedCategoryData.filter(
    (subcategory) => filterByQueryValue !== "" ? subcategory.label.toLowerCase().includes(filterByQueryValue.toLowerCase()) : true
  );
  useEffect5(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!filterByQueryValue) {
      setStatusMessage("");
      return;
    }
    const count = filteredCategories.length;
    debounceRef.current = setTimeout(() => {
      if (count === 0) {
        setStatusMessage("No results found");
      } else if (count === 1) {
        setStatusMessage(`1 result found: ${filteredCategories[0].label}`);
      } else {
        setStatusMessage(`${count} results found`);
      }
    }, 1e3);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [filterByQueryValue]);
  return /* @__PURE__ */ jsx16(React12.Fragment, { children: /* @__PURE__ */ jsxs11(
    ModalDialog2,
    {
      header: currentTopLevelCategory,
      isOpen,
      onClose: () => {
        setIsOpen(false);
        setFilterByQueryValue("");
      },
      css: {
        "abyss-modal-content-container": {
          padding: "16px"
        },
        "abyss-modal-base-header-container": {
          borderBottom: "none"
        }
      },
      children: [
        /* @__PURE__ */ jsx16(
          "div",
          {
            "aria-live": "polite",
            "aria-atomic": "true",
            style: { position: "absolute", width: "1px", height: "1px", overflow: "hidden", clip: "rect(0,0,0,0)", whiteSpace: "nowrap", border: 0 },
            children: statusMessage
          }
        ),
        /* @__PURE__ */ jsx16("div", { children: /* @__PURE__ */ jsx16(
          TextInput5,
          {
            label: `Filter ${(_a = currentCategoryData == null ? void 0 : currentCategoryData.label) != null ? _a : ""} Needs`,
            "data-cy": "filter-categories-input",
            value: filterByQueryValue,
            placeholder: "Type to filter",
            onChange: (e) => {
              return setFilterByQueryValue(e.target.value);
            },
            onClear: () => {
              return setFilterByQueryValue("");
            }
          }
        ) }),
        /* @__PURE__ */ jsx16("div", { role: "group", "aria-label": `Filter ${(_b = currentCategoryData == null ? void 0 : currentCategoryData.label) != null ? _b : ""} Needs`, children: /* @__PURE__ */ jsxs11(
          Grid2,
          {
            style: {
              margin: "0px"
            },
            children: [
              /* @__PURE__ */ jsx16(
                Grid2.Col,
                {
                  span: {
                    xs: 12
                  },
                  children: /* @__PURE__ */ jsx16(
                    HoverText,
                    {
                      className: "commoncategoryHover",
                      onClick: () => {
                        onClickCategoryFilter(currentCategoryData, "");
                        setFilterByQueryValue("");
                        setIsOpen(false);
                      },
                      "data-cy": `select-all-${prettyTextToKebabCase(
                        (_c = currentCategoryData == null ? void 0 : currentCategoryData.label) != null ? _c : ""
                      )}-filters-btn`,
                      children: "All"
                    }
                  )
                }
              ),
              filteredCategories.map((subcategory) => {
                return /* @__PURE__ */ jsx16(Grid2.Col, { children: /* @__PURE__ */ jsx16(
                  HoverText,
                  {
                    className: "commoncategoryHover",
                    onClick: () => {
                      var _a2;
                      onClickCategoryFilter(
                        subcategory,
                        (_a2 = currentCategoryData == null ? void 0 : currentCategoryData.label) != null ? _a2 : ""
                      );
                      setFilterByQueryValue("");
                      setIsOpen(false);
                    },
                    "data-cy": `select-${prettyTextToKebabCase(
                      subcategory.label
                    )}-filters-btn`,
                    children: subcategory.label.charAt(0).toUpperCase() + subcategory.label.slice(1).toLowerCase()
                  }
                ) }, subcategory.id);
              }, [])
            ]
          }
        ) })
      ]
    }
  ) });
};

// src/UniteUsServicesInput/UniteUsServicesInput.tsx
import { SearchInput as SearchInputBase } from "@uhg-abyss/web/ui/SearchInput";
import { useMemo as useMemo3, useState as useState12, useEffect as useEffect6 } from "react";
import { Fragment, jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";
var SearchInput2 = SearchInputBase;
function UniteUsServicesInput({
  model,
  isRequired,
  services,
  onChange,
  defaultCategory
}) {
  const options = useMemo3(() => {
    const inverted = flatInvertTree(services);
    return intoSearchInputOptions(inverted);
  }, [services]);
  const [inputValue, setInputValue] = useState12(defaultCategory != null ? defaultCategory : "");
  useEffect6(() => {
    setInputValue(defaultCategory != null ? defaultCategory : "");
  }, [defaultCategory]);
  const validators = useMemo3(() => ({
    required: isRequired ? "Please select a need" : void 0
  }), [isRequired]);
  return /* @__PURE__ */ jsx17(
    SearchInput2,
    {
      id: "uniteus-services-input",
      placeholder: "Search...",
      label: isRequired ? /* @__PURE__ */ jsxs12(Fragment, { children: [
        "Search",
        /* @__PURE__ */ jsx17("span", { "aria-hidden": "true", style: { color: "#C40000", marginLeft: "4px" }, children: "*" })
      ] }) : "Search",
      isTypeAhead: true,
      searchConfig: { keys: ["label"], threshold: 0.2, shouldSort: true, maxResults: 15, ignoreLocation: true },
      validators,
      isClearable: true,
      value: inputValue,
      onInputChange: (val) => {
        setInputValue(val);
        onChange == null ? void 0 : onChange(val, null);
      },
      onSearch: (inputValue2, selectedOpt) => {
        var _a;
        const opt = selectedOpt && typeof selectedOpt === "object" && "label" in selectedOpt ? selectedOpt : null;
        const label = (_a = opt == null ? void 0 : opt.label) != null ? _a : inputValue2;
        setInputValue(label);
        onChange == null ? void 0 : onChange(label, opt);
      },
      onClear: () => {
        setInputValue("");
        onChange == null ? void 0 : onChange("", null);
      },
      options,
      customRender: (item) => /* @__PURE__ */ jsxs12("div", { children: [
        /* @__PURE__ */ jsxs12("b", { style: { color: "#196ECF" }, children: [
          " ",
          item.label,
          " "
        ] }),
        /* @__PURE__ */ jsx17("span", { children: item.parent ? ` in ${item.parent}` : "" })
      ] })
    }
  );
}
function intoSearchInputOptions(inverted) {
  return inverted.map((node) => {
    var _a;
    return {
      value: String(node.id),
      label: node.label,
      id: node.id,
      parent: (_a = node.parent) == null ? void 0 : _a.label
    };
  });
}
function flatInvertTree(tree) {
  const result = [];
  function traverse(node, parent) {
    result.push({
      id: node.id,
      label: node.label,
      parent
    });
    if (node.children) {
      node.children.forEach((child) => {
        traverse(child, node);
      });
    }
  }
  tree.forEach((node) => {
    traverse(node);
  });
  return result;
}

// src/UniteUsFilterPanel/UniteUsFilterPanel.tsx
import { SelectInput as SelectInput4 } from "@uhg-abyss/web/ui/SelectInput";
import { CheckboxGroup as CheckboxGroup3 } from "@uhg-abyss/web/ui/CheckboxGroup";
import { Checkbox as Checkbox4 } from "@uhg-abyss/web/ui/Checkbox";
import { Heading as Heading3 } from "@uhg-abyss/web/ui/Heading";
import { jsx as jsx18, jsxs as jsxs13 } from "react/jsx-runtime";
function popKeyToDisplay(key) {
  const abbreviationPhrases = ["lgbtq", "hiv", "aids"];
  const abbreviationSubstitutions = {
    plus: "+"
  };
  const properNouns = ["americans", "alaska"];
  return key.split("_").map((word, idx) => {
    if (abbreviationPhrases.includes(word)) {
      return word.toUpperCase();
    }
    if (abbreviationSubstitutions[word]) {
      return abbreviationSubstitutions[word];
    }
    return idx === 0 || properNouns.includes(word) ? word.charAt(0).toUpperCase() + word.slice(1) : word;
  }).join(" ");
}
function UniteUsFilterPanel({
  populationFiltersList,
  currentPopulationRestrictions,
  currentPopulationServing,
  setPopulationRestrictions,
  setPopulationServing,
  distanceRadius,
  setDistanceRadius,
  sortBy,
  setSortBy
}) {
  return /* @__PURE__ */ jsxs13("div", { "data-cy": "uniteus-filters-panel-container", children: [
    /* @__PURE__ */ jsx18(Heading3, { level: 3, size: "sm", children: "Filters" }),
    /* @__PURE__ */ jsx18(
      SelectInput4,
      {
        label: "Sort by",
        options: [
          { value: "relevance", label: "Relevance" },
          { value: "distance", label: "Distance" }
        ],
        value: sortBy,
        onChange: (value) => {
          setSortBy(value);
        }
      }
    ),
    /* @__PURE__ */ jsx18(
      SelectInput4,
      {
        "data-cy": "distance-radius-select",
        label: "Distance radius (miles)",
        value: distanceRadius,
        onChange: (selected) => {
          setDistanceRadius(selected);
        },
        options: [
          { value: 5, label: "5" },
          { value: 10, label: "10" },
          { value: 25, label: "25" },
          { value: 50, label: "50" },
          { value: 100, label: "100" }
        ]
      }
    ),
    /* @__PURE__ */ jsx18(
      CheckboxGroup3,
      {
        "data-cy": "population-serving-checkbox-group",
        label: "Serving populations",
        value: currentPopulationServing,
        onChange: (selected) => {
          setPopulationServing(selected);
        },
        children: /* @__PURE__ */ jsx18(CheckboxGroup3.Column, { children: populationFiltersList.map((key) => {
          return /* @__PURE__ */ jsx18(
            Checkbox4,
            {
              "data-cy": "population-serving-checkbox",
              value: key,
              label: popKeyToDisplay(key)
            },
            key
          );
        }) })
      }
    )
  ] });
}

// src/CboSearchForm/CboSearchForm.tsx
import React16, { useEffect as useEffect9, useMemo as useMemo5, useState as useState15, useRef as useRef4 } from "react";
import { Grid as Grid3 } from "@uhg-abyss/web/ui/Grid";

// src/ZipcodeSearchInput/ZipcodeSearchInput.tsx
import React14, { useEffect as useEffect7, useState as useState13, useRef as useRef2 } from "react";
import { SearchInput as SearchInputBase2, SearchInputChangeTypes } from "@uhg-abyss/web/ui/SearchInput";
import { IconSymbol as IconSymbol3 } from "@uhg-abyss/web/ui/IconSymbol";
import { useCallback as useCallback3 } from "react";
import { Fragment as Fragment2, jsx as jsx19, jsxs as jsxs14 } from "react/jsx-runtime";
var SearchInput3 = SearchInputBase2;
function ZipcodeSearchInput({
  model,
  validators,
  defaultValue,
  fetchLocationInfo,
  onChange,
  onInputChange,
  isRequired,
  errorMessage
}) {
  const [isLoading, setLoading] = useState13(false);
  const [isFirstRender, setIsFirstRender] = useState13(true);
  const committedZipRef = useRef2("");
  const onChangeRef = useRef2(onChange);
  onChangeRef.current = onChange;
  const onInputChangeRef = useRef2(onInputChange);
  onInputChangeRef.current = onInputChange;
  const [fieldValue, setFieldValue] = useState13("");
  const [displayValue, setDisplayValue] = useState13("");
  const [searchResults, setSearchResults] = useState13([]);
  useEffect7(() => {
    function onFirstRender() {
      return __async(this, null, function* () {
        if (!defaultValue) {
          return;
        }
        const results = yield fetchLocationInfo(defaultValue);
        const directMatch = results == null ? void 0 : results.find(
          (location) => location.zipcode === defaultValue
        );
        if (directMatch) {
          committedZipRef.current = directMatch.zipcode;
          setFieldValue(directMatch.zipcode);
          setDisplayValue(intoLabel(directMatch));
          onChange == null ? void 0 : onChange(directMatch.zipcode);
        } else {
          committedZipRef.current = defaultValue;
          setFieldValue(defaultValue);
          setDisplayValue(defaultValue);
          onChange == null ? void 0 : onChange(defaultValue);
        }
      });
    }
    if (isFirstRender) {
      onFirstRender();
      setIsFirstRender(false);
    }
  }, []);
  const handleInputChange = useCallback3(
    (inputValue, changeType) => __async(null, null, function* () {
      var _a, _b, _c;
      const isArrowNav = changeType === SearchInputChangeTypes.ArrowNavigation;
      const isShortInput = inputValue.length <= 2;
      const hasComma = inputValue.includes(",");
      setDisplayValue(inputValue);
      if (!isArrowNav) {
        (_a = onInputChangeRef.current) == null ? void 0 : _a.call(onInputChangeRef);
        if (inputValue === "") {
          committedZipRef.current = "";
          setFieldValue("");
          (_b = onChangeRef.current) == null ? void 0 : _b.call(onChangeRef, "");
        } else if (/^\d{5}$/.test(inputValue)) {
          committedZipRef.current = inputValue;
          setFieldValue(inputValue);
          (_c = onChangeRef.current) == null ? void 0 : _c.call(onChangeRef, inputValue);
        }
      }
      if (isShortInput || hasComma || isArrowNav) {
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const fetched = yield fetchLocationInfo(inputValue);
        if (!fetched) {
          console.error(
            `Could not fetch location info for input value: ${inputValue}`
          );
          return;
        }
        const data = fetched.map(intoSearchInputOption);
        setSearchResults(data);
      } catch (error) {
        console.error("Error fetching location info:", error);
      } finally {
        setLoading(false);
      }
    }),
    [fetchLocationInfo]
  );
  return /* @__PURE__ */ jsxs14(React14.Fragment, { children: [
    /* @__PURE__ */ jsx19(
      SearchInput3,
      {
        placeholder: "Location...",
        validators,
        model,
        isTypeAhead: true,
        searchConfig: false,
        inputLeftElement: /* @__PURE__ */ jsx19(IconSymbol3, { icon: "location_on" }),
        value: displayValue,
        label: isRequired ? /* @__PURE__ */ jsxs14(Fragment2, { children: [
          "Location",
          /* @__PURE__ */ jsx19("span", { "aria-hidden": "true", style: { color: "#C40000", marginLeft: "4px" }, children: "*" })
        ] }) : "Location",
        isClearable: true,
        onClear: () => {
          committedZipRef.current = "";
          setFieldValue("");
          setDisplayValue("");
          onChange == null ? void 0 : onChange("");
        },
        isLoading,
        onInputChange: handleInputChange,
        onSearch: (inputValue, selectedOpt) => {
          var _a, _b;
          const opt = selectedOpt && typeof selectedOpt === "object" && "value" in selectedOpt ? selectedOpt : null;
          const zipcode = (_a = opt == null ? void 0 : opt.value) != null ? _a : inputValue;
          const label = (_b = opt == null ? void 0 : opt.label) != null ? _b : inputValue;
          committedZipRef.current = zipcode;
          setFieldValue(zipcode);
          setDisplayValue(label);
          setSearchResults([]);
          onChange == null ? void 0 : onChange(zipcode);
        },
        options: searchResults,
        "data-cy": "zipcode-search-input"
      }
    ),
    errorMessage && /* @__PURE__ */ jsx19("div", { role: "alert", style: { color: "#C40000", fontSize: "0.875rem", marginTop: "4px" }, children: errorMessage })
  ] });
}
function intoLabel(location) {
  return `${location.name}, ${location.state_name} ${location.zipcode}`;
}
function intoSearchInputOption(location) {
  return {
    value: location.zipcode,
    label: intoLabel(location)
  };
}

// src/CboSearchForm/CboSearchForm.tsx
import { useForm as useForm2 } from "@uhg-abyss/web/hooks/useForm";
import { FormProvider as FormProvider2 } from "@uhg-abyss/web/ui/FormProvider";

// src/FindhelpServicesInput/FindhelpServicesInput.tsx
import {
  SearchInput as SearchInputBase3
} from "@uhg-abyss/web/ui/SearchInput";
import React15, { useEffect as useEffect8, useMemo as useMemo4, useState as useState14, useRef as useRef3 } from "react";
import { Fragment as Fragment3, jsx as jsx20, jsxs as jsxs15 } from "react/jsx-runtime";
var SearchInput4 = SearchInputBase3;
var commonCategoriesLabels = [
  "Health",
  "Food",
  "Housing",
  "Money",
  "Transit"
];
function FindhelpServicesInput({
  model,
  isRequired,
  defaultCategory,
  defaultCategoryId,
  services,
  onChange
}) {
  const [inputQuery, setInputQuery] = useState14("");
  const [selectedOption, setSelectedOption] = useState14(null);
  const lastReportedValueRef = useRef3("");
  const options = useMemo4(() => {
    const inverted = flatInvertTree2(services);
    return intoSearchInputOptions2(inverted);
  }, [services]);
  const filteredOptions = useMemo4(() => {
    let filtered = [];
    const query = inputQuery;
    if (!query || query.trim() === "") {
      return [];
    }
    if (query.length < 2) {
      filtered = options.filter(
        (option) => {
          var _a;
          return commonCategoriesLabels.includes((_a = option.label) != null ? _a : "");
        }
      );
      filtered.sort((a, b) => {
        var _a, _b;
        return ((_a = a.label) != null ? _a : "").localeCompare((_b = b.label) != null ? _b : "");
      });
    } else {
      filtered = options.filter((option) => {
        var _a;
        const lowerLabel = ((_a = option.label) != null ? _a : "").toLowerCase();
        const lowerQuery = query.toLowerCase();
        if (lowerLabel.indexOf(lowerQuery) === 0) {
          option.index = 0;
          return true;
        } else if (lowerLabel.indexOf(lowerQuery) > 0) {
          option.index = 1;
          return true;
        }
        return false;
      });
      customizedSort(filtered);
      filtered = limitFilteredArray(filtered);
    }
    filtered.forEach((item) => {
      item.value = item.label;
    });
    return filtered;
  }, [options, inputQuery]);
  const defaultOpt = useMemo4(() => {
    if (defaultCategoryId) {
      const found = options.find((option) => option.id == defaultCategoryId);
      if (found) return found;
    }
    if (defaultCategory) {
      const found = options.find(
        (option) => {
          var _a;
          return ((_a = option.label) != null ? _a : "").toLocaleLowerCase() === defaultCategory.toLocaleLowerCase();
        }
      );
      if (found) return found;
    }
  }, [services, defaultCategory, defaultCategoryId]);
  const lastHydratedDefaultRef = useRef3(void 0);
  useEffect8(() => {
    var _a, _b;
    if (defaultOpt && lastHydratedDefaultRef.current !== defaultOpt.id) {
      setInputQuery((_a = defaultOpt.label) != null ? _a : "");
      setSelectedOption(defaultOpt);
      lastHydratedDefaultRef.current = defaultOpt.id;
      lastReportedValueRef.current = (_b = defaultOpt.label) != null ? _b : "";
    } else if (!defaultOpt && (defaultCategory || defaultCategoryId)) {
      const keyword = defaultCategory != null ? defaultCategory : String(defaultCategoryId != null ? defaultCategoryId : "");
      const hydratedKey = `__freeform__${keyword}`;
      if (keyword && lastHydratedDefaultRef.current !== hydratedKey) {
        setInputQuery(keyword);
        setSelectedOption(null);
        lastHydratedDefaultRef.current = hydratedKey;
        lastReportedValueRef.current = keyword;
        onChange == null ? void 0 : onChange(keyword, null);
      }
    } else if (!defaultOpt && !defaultCategory && !defaultCategoryId && lastHydratedDefaultRef.current !== void 0) {
      setInputQuery("");
      setSelectedOption(null);
      lastHydratedDefaultRef.current = void 0;
      lastReportedValueRef.current = "";
    }
  }, [defaultOpt, defaultCategory, defaultCategoryId]);
  return /* @__PURE__ */ jsx20(React15.Fragment, { children: /* @__PURE__ */ jsx20(
    SearchInput4,
    {
      placeholder: "Search...",
      label: isRequired ? /* @__PURE__ */ jsxs15(Fragment3, { children: [
        "Search",
        /* @__PURE__ */ jsx20("span", { "aria-hidden": "true", style: { color: "#C40000", marginLeft: "4px" }, children: "*" })
      ] }) : "Search",
      isTypeAhead: true,
      model,
      validators: {
        required: isRequired && inputQuery.trim() === "" ? "Please select a need" : void 0
      },
      isClearable: true,
      descriptorsDisplay: "column",
      value: selectedOption ? selectedOption.label : inputQuery,
      onInputChange: (next) => {
        setInputQuery(next);
        if (selectedOption && selectedOption.label !== next) {
          setSelectedOption(null);
        }
        lastReportedValueRef.current = next;
        onChange == null ? void 0 : onChange(next, null);
      },
      onSearch: (_inputValue, selectedOpt) => {
        var _a;
        if (selectedOpt && "label" in selectedOpt) {
          const opt = selectedOpt;
          const label = (_a = opt.label) != null ? _a : "";
          setSelectedOption(opt);
          setInputQuery(label);
          if (label !== lastReportedValueRef.current) {
            lastReportedValueRef.current = label;
            onChange == null ? void 0 : onChange(label, opt);
          }
        }
      },
      onBlur: () => {
        const trimmedQuery = inputQuery.trim();
        if (trimmedQuery !== lastReportedValueRef.current) {
          lastReportedValueRef.current = trimmedQuery;
          onChange == null ? void 0 : onChange(trimmedQuery, selectedOption);
        }
      },
      onClear: () => {
        setInputQuery("");
        setSelectedOption(null);
        if (lastReportedValueRef.current !== "") {
          lastReportedValueRef.current = "";
          onChange == null ? void 0 : onChange("", null);
        }
      },
      options: filteredOptions,
      customRender: (item) => /* @__PURE__ */ jsxs15("div", { children: [
        /* @__PURE__ */ jsxs15("b", { style: { color: "#196ECF" }, children: [
          " ",
          item.value,
          " "
        ] }),
        item.level != 1 && item.parent ? `in ${item.parent}` : ""
      ] })
    }
  ) });
}
function customizedSort(filtered) {
  filtered.sort((a, b) => {
    var _a, _b, _c, _d, _e, _f;
    const levelComparison = ((_a = a.level) != null ? _a : 0) - ((_b = b.level) != null ? _b : 0);
    if (levelComparison === 0) {
      const indexComparison = ((_c = a.index) != null ? _c : 0) - ((_d = b.index) != null ? _d : 0);
      if (indexComparison === 0) {
        return ((_e = a.label) != null ? _e : "").localeCompare((_f = b.label) != null ? _f : "");
      }
      return indexComparison;
    }
    return levelComparison;
  });
}
function limitFilteredArray(filtered) {
  const limitedArray = [];
  let filteredSubCatCount = 0;
  const subCategoryLimit = 5;
  for (let i = 0; i < (filtered == null ? void 0 : filtered.length); i++) {
    if (filtered[i].level === 1 && i > 2) continue;
    else if ((limitedArray == null ? void 0 : limitedArray.length) < 8 && filteredSubCatCount < subCategoryLimit) {
      if (filtered[i].level === 2) filteredSubCatCount += 1;
      limitedArray.push(filtered[i]);
    } else break;
  }
  return limitedArray;
}
function intoSearchInputOptions2(inverted) {
  return inverted.map((node) => {
    var _a;
    return {
      value: node.label,
      label: node.label,
      id: node.id,
      parent: (_a = node.parent) == null ? void 0 : _a.label
    };
  });
}
function flatInvertTree2(tree) {
  const result = [];
  function traverse(node, parent) {
    result.push({ id: node.id, label: node.label, parent });
    if (node.children) {
      node.children.forEach((child) => traverse(child, node));
    }
  }
  tree.forEach((node) => traverse(node));
  return result;
}

// src/CboSearchForm/CboSearchForm.tsx
import { jsx as jsx21, jsxs as jsxs16 } from "react/jsx-runtime";
function CboSearchForm({
  defaultZipcode,
  defaultCategory,
  defaultCategoryId,
  fetchLocationInfo,
  fetchProvider,
  onSubmit,
  findhelpCategoryData,
  uniteUsCategoryData,
  vendor,
  changedZipcode
}) {
  const findhelpSearchOptions = useMemo5(() => {
    const inverted = flatInvertTree3(findhelpCategoryData);
    return intoSearchInputOptions3(inverted);
  }, [findhelpCategoryData]);
  const uniteUsSearchOptions = useMemo5(() => {
    const inverted = flatInvertTree3(uniteUsCategoryData);
    return intoSearchInputOptions3(inverted);
  }, [uniteUsCategoryData]);
  const [categoryError, setCategoryError] = React16.useState(
    void 0
  );
  const [zipcodeError, setZipcodeError] = React16.useState(
    void 0
  );
  const form = useForm2({
    defaultValues: {
      zipcode: defaultZipcode != null ? defaultZipcode : "",
      category: defaultCategory != null ? defaultCategory : ""
    }
  });
  const prevDefaultsRef = useRef4({
    category: defaultCategory,
    zipcode: defaultZipcode
  });
  const watchedZipcode = form.watch("zipcode");
  const [nextVendorForZipcode, setNextVendorForZipcode] = useState15(vendor);
  const categoryInputDisabled = useMemo5(() => {
    return nextVendorForZipcode !== vendor;
  }, [nextVendorForZipcode, vendor]);
  useEffect9(() => {
    if (changedZipcode) {
      changedZipcode(watchedZipcode);
    }
  }, [watchedZipcode]);
  useEffect9(() => {
    function fetchNewProvider() {
      return __async(this, null, function* () {
        const provider = yield fetchProvider(watchedZipcode);
        if (!provider) {
          return;
        }
        const { name } = provider;
        if (!name) {
          return;
        }
        setNextVendorForZipcode(name);
      });
    }
    if (watchedZipcode) {
      fetchNewProvider();
    }
  }, [watchedZipcode]);
  useEffect9(() => {
    if (categoryInputDisabled) {
      form.setValue("category", "");
    }
  }, [categoryInputDisabled]);
  useEffect9(() => {
    const prevDefaults = prevDefaultsRef.current;
    let shouldUpdate = false;
    if (defaultCategory !== prevDefaults.category) {
      const currentCategory = form.getValues("category");
      if (defaultCategory !== void 0 && defaultCategory !== currentCategory) {
        form.setValue("category", defaultCategory);
        shouldUpdate = true;
      }
      prevDefaultsRef.current.category = defaultCategory;
    }
    if (defaultZipcode !== prevDefaults.zipcode) {
      const currentZipcode = form.getValues("zipcode");
      if (defaultZipcode !== void 0 && defaultZipcode !== currentZipcode) {
        form.setValue("zipcode", defaultZipcode);
        shouldUpdate = true;
      }
      prevDefaultsRef.current.zipcode = defaultZipcode;
    }
  }, [defaultCategory, defaultZipcode]);
  const handleCategoryChange = React16.useCallback(
    (value) => {
      form.setValue("category", value);
      if (value.trim()) setCategoryError(void 0);
    },
    [form]
  );
  return /* @__PURE__ */ jsx21(React16.Fragment, { children: /* @__PURE__ */ jsx21(
    FormProvider2,
    {
      state: form,
      onSubmit: (formState) => {
        var _a;
        const { category, zipcode } = formState;
        let hasError = false;
        if (!categoryInputDisabled && !category.trim()) {
          setCategoryError("Please select a need");
          hasError = true;
        }
        if (!zipcode.trim()) {
          setZipcodeError("Please enter a location");
          hasError = true;
        }
        if (hasError) return;
        const services = vendor === "findhelp" ? findhelpSearchOptions : uniteUsSearchOptions;
        const selectedService = services.find(
          (service) => service.label === category
        );
        const categoryId = (_a = selectedService == null ? void 0 : selectedService.id) != null ? _a : null;
        onSubmit({ label: category, id: categoryId }, zipcode);
      },
      children: /* @__PURE__ */ jsxs16(Grid3, { style: { alignItems: "flex-start" }, children: [
        /* @__PURE__ */ jsx21(Grid3.Col, { span: { xs: 12, lg: 5 }, children: vendor === "findhelp" ? /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx21(
            FindhelpServicesInput,
            {
              defaultCategory: categoryInputDisabled ? "" : defaultCategory,
              defaultCategoryId: categoryInputDisabled ? void 0 : defaultCategoryId,
              isRequired: !categoryInputDisabled,
              model: "category",
              services: findhelpCategoryData,
              onChange: handleCategoryChange
            }
          ),
          categoryError && /* @__PURE__ */ jsx21(
            "div",
            {
              role: "alert",
              style: {
                color: "#C40000",
                fontSize: "0.875rem",
                marginTop: "4px"
              },
              children: categoryError
            }
          )
        ] }) : /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx21(
            UniteUsServicesInput,
            {
              defaultCategory: categoryInputDisabled ? "" : defaultCategory,
              defaultCategoryId: categoryInputDisabled ? void 0 : defaultCategoryId,
              isRequired: !categoryInputDisabled,
              model: "category",
              services: uniteUsCategoryData,
              onChange: handleCategoryChange
            }
          ),
          categoryError && /* @__PURE__ */ jsx21(
            "div",
            {
              role: "alert",
              style: {
                color: "#C40000",
                fontSize: "0.875rem",
                marginTop: "4px"
              },
              children: categoryError
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx21(Grid3.Col, { span: { xs: 12, lg: 5 }, children: /* @__PURE__ */ jsx21(
          ZipcodeSearchInput,
          {
            validators: { required: true },
            fetchLocationInfo,
            model: "zipcode",
            defaultValue: defaultZipcode,
            isRequired: true,
            errorMessage: zipcodeError,
            onInputChange: () => setZipcodeError(void 0),
            onChange: (zipcode) => {
              form.setValue("zipcode", zipcode);
              if (zipcode.trim()) setZipcodeError(void 0);
            }
          }
        ) }),
        /* @__PURE__ */ jsx21(Grid3.Col, { span: { xs: 12, lg: 1 }, style: { paddingTop: "40px" }, children: /* @__PURE__ */ jsx21(Button, { type: "submit", children: "Search" }) })
      ] })
    }
  ) });
}
function flatInvertTree3(tree) {
  const result = [];
  function traverse(node, parent) {
    result.push({
      id: node.id,
      label: node.label,
      parent
    });
    if (node.children) {
      node.children.forEach((child) => {
        traverse(child, node);
      });
    }
  }
  tree.forEach((node) => {
    traverse(node);
  });
  return result;
}
function intoSearchInputOptions3(inverted) {
  return inverted.map((node) => {
    var _a;
    return {
      value: node.label,
      label: node.label,
      id: node.id,
      parent: (_a = node.parent) == null ? void 0 : _a.label
    };
  });
}

// src/tools/events/index.tsx
import { event } from "@uhg-abyss/web/tools/event";

// src/tools/events/tags/adobe/index.tsx
var getPageData = (data) => {
  return {
    referringSite: document.referrer,
    language: "english",
    experienceType: "desktop",
    is404: false,
    name: data.page,
    // Refer Taxonomy Table (Column: “Page Level Content”).
    sitesection1: "secure",
    sitesection2: "wellness",
    sitesection3: "community resources",
    sitesection4: "",
    test: "",
    group: data.group
    // examples: product, search, content
  };
};
var getUserData = (data) => {
  return {
    loginStatus: "logged in",
    userType: `member>${data.lob}`,
    groupId: "",
    carrierId: "",
    hsid: "",
    rallyId: "",
    patientId: "",
    // This value is required to be encrypted. If you do not encrypt it, the value is PII and you will be accountable for passing it. See encryption logic in the linked document below.
    payerGroup: data.lob,
    memberId: ""
  };
};
var getUserId = (data) => {
  return {
    userId: data.userId
  };
};
var getLinkData = (data) => {
  return {
    name: data.name,
    // Ex: "Go to My Activity", “helping you find resources:take quiz” based on UI value.
    location: data.location,
    // Ex: "browse common category section", “get matched resources”, “faq section” - Based on UI Link Location (Section/Body Content)
    type: "internal",
    // Ex: "internal" || "external" based on link functionality.
    destinationUrl: data.destination
    // leave blank when link does not point to a URL
  };
};
var getSearchData = (data) => {
  return {
    term: data.term,
    // Ex: “all emergency”, “temporary shelter”
    type: "community search",
    // Ex: “community search”, “site”
    filters: [],
    // if filters are applied; for multiple values separate them with a "|" delimiter
    results: "",
    // set to "zero" if 0 search results are returned
    method: "typed"
    // Ex: typed, autofill
  };
};
var getFormStartData = (data) => {
  return {
    name: data.name
    // Ex: “get all the benefits you deserve”, “helping you find resources”
  };
};
var getFormEnd = (data) => {
  return {
    name: data.name
    // Ex: “get all the benefits you deserve”, “helping you find resources” };
  };
};
var adobeTags = {
  PAGE_LOAD: (data) => {
    return {
      event: "page track",
      data: {
        page: __spreadValues({}, getPageData(data)),
        user: __spreadValues({}, getUserData(data))
      }
    };
  },
  LINK_LOAD: (data) => {
    return {
      event: "link track",
      data: {
        link: __spreadValues({}, getLinkData(data))
      }
    };
  },
  SEARCH_LOAD: (data) => {
    return {
      event: "standard search",
      data: {
        search: __spreadValues({}, getSearchData(data))
      }
    };
  },
  FORM_START_LOAD: (data) => {
    return {
      event: "form started",
      data: {
        form: __spreadValues({}, getFormStartData(data))
      }
    };
  },
  FORM_END_LOAD: (data) => {
    return {
      event: "form complete",
      data: {
        form: __spreadValues({}, getFormEnd(data))
      }
    };
  },
  EMAIL_CLICK: (data) => {
    return {
      event: "email clicked",
      data: {
        user: __spreadValues({}, getUserId(data))
      }
    };
  }
};

// src/tools/events/index.tsx
var ADOBE_ANALYTICS_ID = "adobe-analytics-communityconnector";
var registerEvents = (metaData) => {
  event.listener({
    id: ADOBE_ANALYTICS_ID,
    trigger: (tag) => {
      if (typeof window !== "undefined") {
        const dataLayer = window.adobeDataLayer = window.adobeDataLayer || [];
        dataLayer.push(tag);
      }
    },
    events: adobeTags,
    metadata: metaData
  });
};

// src/Autocomplete/LocationAzureAutocomplete.tsx
import React17, { useState as useState17, useEffect as useEffect10, useMemo as useMemo6, useCallback as useCallback5 } from "react";
import { IconSymbol as IconSymbol4 } from "@uhg-abyss/web/ui/IconSymbol";
import { Text as Text6 } from "@uhg-abyss/web/ui/Text";
import { SearchInput as SearchInputBase4 } from "@uhg-abyss/web/ui/SearchInput";

// src/Autocomplete/useAzureMapsAutocomplete.ts
import { useState as useState16, useCallback as useCallback4, useRef as useRef5 } from "react";

// src/Autocomplete/utils/azureMapsApi.ts
var AZURE_MAPS_SEARCH_API_URL = "https://atlas.microsoft.com/geocode:autocomplete";
var AZURE_MAPS_API_VERSION = "2025-06-01-preview";
var US_ALL_STATES_BBOX = "-180,18,-66,72";
function fetchAzureMapsAutocomplete(query, subscriptionKey, signal, coordinates) {
  return __async(this, null, function* () {
    if (!query.trim() || !subscriptionKey) {
      return [];
    }
    const params = new URLSearchParams({
      "api-version": AZURE_MAPS_API_VERSION,
      "subscription-key": subscriptionKey,
      query,
      countryRegion: "US",
      resultTypeGroups: "Place",
      resultTypes: "PopulatedPlace,Postcode1",
      top: "10"
    });
    if (coordinates) {
      params.append("coordinates", `${coordinates.lon},${coordinates.lat}`);
    } else {
      params.append("bbox", US_ALL_STATES_BBOX);
    }
    const url = `${AZURE_MAPS_SEARCH_API_URL}?${params}`;
    const response = yield fetch(url, {
      signal,
      headers: {
        "Accept-Language": "en-US"
      }
    });
    if (!response.ok) {
      const errorText = yield response.text();
      if (process.env.NODE_ENV === "development") {
        console.error("Azure Maps API error response:", errorText);
      }
      throw new Error(`Azure Maps API error: ${response.status}`);
    }
    const data = yield response.json();
    const predictions = parseAzureMapsResponse(data);
    return predictions;
  });
}
function geocodeZipcode(zipcode, subscriptionKey) {
  return __async(this, null, function* () {
    if (!zipcode.trim() || !subscriptionKey) {
      return null;
    }
    const zipMatch = zipcode.match(/^(\d{5})(?:-\d{4})?$/);
    if (!zipMatch) {
      return null;
    }
    return geocodeLocation(zipcode, subscriptionKey);
  });
}
function geocodeLocation(query, subscriptionKey) {
  return __async(this, null, function* () {
    if (!query.trim() || !subscriptionKey) {
      return null;
    }
    const params = new URLSearchParams({
      "api-version": AZURE_MAPS_API_VERSION,
      "subscription-key": subscriptionKey,
      query,
      countryRegion: "US",
      resultTypeGroups: "Place",
      resultTypes: "Postcode1",
      top: "1",
      bbox: US_ALL_STATES_BBOX
    });
    const url = `${AZURE_MAPS_SEARCH_API_URL}?${params}`;
    try {
      const response = yield fetch(url, {
        headers: {
          "Accept-Language": "en-US"
        }
      });
      if (!response.ok) {
        if (process.env.NODE_ENV === "development") {
          console.error("Azure Maps Geocode API error:", yield response.text());
        }
        return null;
      }
      const data = yield response.json();
      const results = parseAzureMapsResponse(data);
      return results.length > 0 ? results[0] : null;
    } catch (error) {
      if (process.env.NODE_ENV === "development") {
        console.error("Error geocoding ZIP code:", error);
      }
      return null;
    }
  });
}
function parseAzureMapsResponse(data) {
  if (!(data == null ? void 0 : data.features) || !Array.isArray(data.features)) {
    return [];
  }
  const results = data.features.map((feature) => {
    var _a, _b;
    const properties = feature.properties;
    const address = properties == null ? void 0 : properties.address;
    if (!address) return null;
    const countryISO = ((_a = address.countryRegion) == null ? void 0 : _a.ISO) || "";
    if (countryISO && countryISO.toUpperCase() !== "US") return null;
    const city = address.locality || "";
    const stateObj = (_b = address.adminDistricts) == null ? void 0 : _b[0];
    const state = (stateObj == null ? void 0 : stateObj.shortName) || (stateObj == null ? void 0 : stateObj.name) || "";
    if (!city) return null;
    const postalCode = address.postalCode || "";
    const zipMatch = postalCode.match(/^(\d{5})(?:-\d{4})?$/);
    if (zipMatch) {
      const zipCode = zipMatch[1];
      const label = [city, state, zipCode].filter(Boolean).join(", ");
      return { label, value: zipCode, state, city, postalCode: zipCode, raw: feature };
    } else {
      const label = [city, state].filter(Boolean).join(", ");
      const value = label;
      return { label, value, state, city, postalCode: "", raw: feature, needsGeocode: true };
    }
  }).filter((item) => item !== null).reduce((unique, item) => {
    if (!unique.find((u) => u.label === item.label)) unique.push(item);
    return unique;
  }, []);
  return results;
}

// src/Autocomplete/useAzureMapsAutocomplete.ts
var useAzureMapsAutocomplete = (subscriptionKey, coordinates) => {
  const [results, setResults] = useState16([]);
  const abortControllerRef = useRef5(null);
  const getPlacePredictions = useCallback4(
    (query) => {
      if (!subscriptionKey) {
        console.warn("Azure Maps subscription key not provided");
        setResults([]);
        return;
      }
      if (!query.trim()) {
        setResults([]);
        return;
      }
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();
      const signal = abortControllerRef.current.signal;
      (() => __async(null, null, function* () {
        try {
          const predictions = yield fetchAzureMapsAutocomplete(
            query,
            subscriptionKey,
            signal,
            coordinates
          );
          setResults(predictions);
        } catch (error) {
          if (error.name !== "AbortError") {
            console.error("Azure Maps API error:", error);
            setResults([]);
          }
        }
      }))();
    },
    [subscriptionKey, coordinates]
  );
  return {
    results,
    getPlacePredictions
  };
};

// src/Autocomplete/LocationAzureAutocomplete.tsx
import { jsx as jsx22, jsxs as jsxs17 } from "react/jsx-runtime";
var SearchInput5 = SearchInputBase4;
var LocationAzureAutocomplete = React17.memo(
  ({
    sendZipcode,
    ipZipcode,
    label = "Location",
    subscriptionKey,
    coordinates,
    isRequired = true,
    triggerValidation = false,
    onClear
  }) => {
    const [inputValue, setInputValue] = useState17("");
    const [selectedValue, setSelectedValue] = useState17("");
    const [selectedResult, setSelectedResult] = useState17(null);
    const [isInitialized, setIsInitialized] = useState17(false);
    const [initialResult, setInitialResult] = useState17(null);
    const [hasValidSelection, setHasValidSelection] = useState17(false);
    const [showValidationError, setShowValidationError] = useState17(false);
    const [geocodeErrorMessage, setGeocodeErrorMessage] = useState17(null);
    const lastSentZipcodeRef = React17.useRef("");
    const sendZipcodeRef = React17.useRef(sendZipcode);
    useEffect10(() => {
      sendZipcodeRef.current = sendZipcode;
    }, [sendZipcode]);
    useEffect10(() => {
      if (triggerValidation && !hasValidSelection && !/^\d{5}$/.test(inputValue.trim())) {
        setShowValidationError(true);
      }
    }, [triggerValidation, hasValidSelection, inputValue]);
    const { results, getPlacePredictions } = useAzureMapsAutocomplete(
      subscriptionKey,
      coordinates
    );
    const lookupOptions = useMemo6(
      () => initialResult && !results.some((r) => r.value === initialResult.value) ? [initialResult, ...results] : results,
      [initialResult, results]
    );
    const displayOptions = useMemo6(
      () => inputValue && inputValue.length > 0 ? results : [],
      [inputValue, results]
    );
    const handleInputChange = useCallback5(
      (newInputValue) => {
        setInputValue(newInputValue);
        setGeocodeErrorMessage(null);
        if (showValidationError) {
          setShowValidationError(false);
        }
        if (hasValidSelection && newInputValue !== selectedValue) {
          setHasValidSelection(false);
        }
        if (newInputValue && newInputValue.length > 0) {
          getPlacePredictions(newInputValue);
        }
      },
      [getPlacePredictions, hasValidSelection, showValidationError, selectedValue]
    );
    const handleChange = useCallback5(
      (selectedValue2) => {
        var _a;
        const result = (_a = lookupOptions.find((r) => r.value === selectedValue2)) != null ? _a : lookupOptions.find((r) => r.label === selectedValue2);
        if (result) {
          if (result.needsGeocode) {
            setInputValue(result.label);
            setSelectedValue(result.value);
            setHasValidSelection(false);
            setGeocodeErrorMessage(null);
            geocodeLocation(`${result.city} ${result.state}`, subscriptionKey).then((geocoded) => {
              if (geocoded == null ? void 0 : geocoded.postalCode) {
                setSelectedValue(geocoded.value);
                setInputValue(geocoded.postalCode);
                setSelectedResult(geocoded);
                setHasValidSelection(true);
                setShowValidationError(false);
                setGeocodeErrorMessage(null);
              } else {
                setInputValue("");
                setGeocodeErrorMessage(`Couldn't find a Zipcode for "${result.label}". Please type the Zipcode directly.`);
              }
            });
          } else {
            setSelectedValue(result.value);
            setInputValue(result.postalCode);
            setSelectedResult(result);
            setHasValidSelection(true);
            setShowValidationError(false);
          }
        } else if (/^\d{5}$/.test(selectedValue2.trim())) {
          const zip = selectedValue2.trim();
          const syntheticResult = { value: zip, label: zip, postalCode: zip, state: "", city: "", raw: null };
          setSelectedValue(zip);
          setInputValue(zip);
          setSelectedResult(syntheticResult);
          setHasValidSelection(true);
          setShowValidationError(false);
          if (zip !== lastSentZipcodeRef.current) {
            lastSentZipcodeRef.current = zip;
            sendZipcodeRef.current(syntheticResult);
          }
        }
      },
      [lookupOptions, subscriptionKey]
    );
    const handleClear = useCallback5(() => {
      setInputValue("");
      setSelectedValue("");
      setSelectedResult(null);
      setHasValidSelection(false);
      setShowValidationError(false);
      setGeocodeErrorMessage(null);
      onClear == null ? void 0 : onClear();
    }, [onClear]);
    const handleBlur = useCallback5(() => {
      const zip = inputValue.trim();
      if (!hasValidSelection && /^\d{5}$/.test(zip)) {
        handleChange(zip);
        return;
      }
      if (isRequired && !hasValidSelection && zip !== "") {
        setShowValidationError(true);
      }
    }, [isRequired, hasValidSelection, inputValue, handleChange]);
    const handleKeyDown = useCallback5(
      (event2) => {
        if (event2.key === "Enter" && results.length > 0 && inputValue) {
          event2.preventDefault();
          const firstResult = results[0];
          handleChange(firstResult.value);
        }
      },
      [results, inputValue, handleChange]
    );
    useEffect10(() => {
      if (ipZipcode && subscriptionKey && !isInitialized) {
        geocodeZipcode(ipZipcode, subscriptionKey).then((result) => {
          if (result) {
            setSelectedValue(result.value);
            setInputValue(result.postalCode);
            setSelectedResult(result);
            setInitialResult(result);
            setHasValidSelection(true);
            setIsInitialized(true);
          } else {
            setInputValue(ipZipcode);
            setSelectedValue(ipZipcode);
            setIsInitialized(true);
          }
        });
      } else if (ipZipcode && !subscriptionKey && !isInitialized) {
        setInputValue(ipZipcode);
        setSelectedValue(ipZipcode);
      }
    }, [ipZipcode, subscriptionKey, isInitialized]);
    useEffect10(() => {
      if (selectedResult && selectedResult.postalCode !== lastSentZipcodeRef.current) {
        lastSentZipcodeRef.current = selectedResult.postalCode;
        sendZipcodeRef.current(selectedResult);
      }
    }, [selectedResult]);
    return /* @__PURE__ */ jsxs17("div", { onKeyDown: handleKeyDown, children: [
      /* @__PURE__ */ jsx22(
        SearchInput5,
        {
          label: /* @__PURE__ */ jsxs17(Text6, { color: "$core.color.brand.100", fontWeight: "bold", fontSize: "md", children: [
            label,
            isRequired && /* @__PURE__ */ jsx22("span", { "aria-hidden": "true", style: { color: "#C40000", marginLeft: "4px" }, children: "*" })
          ] }),
          descriptorsDisplay: "column",
          options: displayOptions,
          value: selectedValue,
          labelKey: "postalCode",
          customRender: (item) => item.label,
          onSearch: (searchText, selectedOpt) => {
            var _a, _b, _c;
            const value = (_c = (_b = selectedOpt == null ? void 0 : selectedOpt.value) != null ? _b : (_a = lookupOptions.find((r) => r.label === searchText)) == null ? void 0 : _a.value) != null ? _c : searchText;
            handleChange(value);
          },
          onInputChange: handleInputChange,
          onBlur: handleBlur,
          onClear: handleClear,
          isClearable: true,
          isTypeAhead: true,
          isRequired,
          placeholder: "Enter location...",
          inputLeftElement: /* @__PURE__ */ jsx22(IconSymbol4, { icon: "location_on", size: "18px", color: "$core.color.brand.60" }),
          "data-cy": "abyss-search-input-input",
          css: {
            "abyss-search-input-input": {
              border: "solid 1px #196ecf"
            }
          }
        }
      ),
      isRequired && showValidationError && !hasValidSelection && !/^\d{5}$/.test(inputValue.trim()) && /* @__PURE__ */ jsxs17(
        "div",
        {
          role: "alert",
          style: {
            color: "#990000",
            fontSize: ".9rem",
            fontWeight: "600",
            marginTop: "4px",
            paddingLeft: "2px",
            display: "flex",
            alignItems: "center",
            gap: "4px"
          },
          children: [
            /* @__PURE__ */ jsx22(IconSymbol4, { variant: "outlined", icon: "error", size: "16px", color: "#990000" }),
            "Please enter a valid Zipcode"
          ]
        }
      ),
      geocodeErrorMessage && /* @__PURE__ */ jsxs17(
        "div",
        {
          role: "alert",
          style: {
            color: "#990000",
            fontSize: ".9rem",
            fontWeight: "600",
            marginTop: "4px",
            paddingLeft: "2px",
            display: "flex",
            alignItems: "center",
            gap: "4px"
          },
          children: [
            /* @__PURE__ */ jsx22(IconSymbol4, { variant: "outlined", icon: "error", size: "16px", color: "#990000" }),
            geocodeErrorMessage
          ]
        }
      )
    ] });
  }
);
LocationAzureAutocomplete.displayName = "LocationAzureAutocomplete";
export {
  BulkReferDropdownButton,
  Button,
  Categories,
  CboCardFindhelpNextSteps,
  CboCardUniteUs,
  CboCardUniteUsNextSteps,
  CboSearchForm,
  CheckBoxTextBox,
  CheckboxGroupQtn,
  CommonModal,
  Dropdown,
  FindhelpServicesInput,
  LocationAzureAutocomplete,
  MultiSelect,
  RadioDropdown,
  RadioGroupQtn,
  RadioTextBox,
  SearchBar,
  SingleQuestionPerPageUI,
  UniteUsFilterPanel,
  UniteUsServicesInput,
  ZipcodeSearchInput,
  registerEvents
};
/*! Bundled license information:

dompurify/dist/purify.es.mjs:
  (*! @license DOMPurify 3.4.12 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.12/LICENSE *)
*/
//# sourceMappingURL=index.js.map